// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:39:57.205Z
// Property: Clear Springs (ID: 5767618778628096)
// Collections: 20 amenities, 4 floorplans (live), 17 photos, 86 POIs, 1 virtual tours, 7 office hours, 1 special offers (live), 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5767618778628096",
  "property_external_id": "4981184",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/clear-springs-new-braunfels-tx/kn6fck8",
  "property_google_business_url": "https://www.google.com/maps/place/Clear+Springs+Apartments/data=!4m2!3m1!1s0x0:0x3223288e4cb4f35e?sa=X&ved=2ahUKEwjxhd_gtrySAxWHWEEAHZDfEb8Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443948915",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "clear-springs",
  "property_name": "Clear Springs",
  "property_website_url": "https://www.clearspringsapts.com/",
  "property_domain": "https://www.clearspringsapts.com/",
  "property_address": "1767 S State Highway 46",
  "property_full_address": "1767 TX-46, New Braunfels, TX 78130",
  "property_address_1": "1767 TX-46",
  "property_address_2": null,
  "property_address_city": "New Braunfels",
  "property_address_state": "TX",
  "property_address_zip_full": "78130-0237",
  "property_address_zip": "78130",
  "property_address_country": "US",
  "property_address_county": "Guadalupe County",
  "property_neighborhood_address": "Guadalupe County",
  "property_address_latitude": "29.675722",
  "property_address_longitude": "-98.0569148",
  "property_email": "clearsprings@alapts.com",
  "property_phone": "(830) 837-5885",
  "property_call_tracking_phone": "830-218-0871",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern comfort with Hill Country momentum.</strong> Clear Springs pairs polished one- and two-bedroom apartments with everyday conveniences along TX-46 in New Braunfels—schedule a tour and see how easy home can feel.</p>",
  "property_long_description": "<p><strong>Modern comfort with Hill Country momentum.</strong> At Clear Springs, you’re set along TX-46 in New Braunfels with one- and two-bedroom <a href=\"/floor-plans\">apartment layouts</a> designed for easy everyday living. Inside, hard-surface flooring, tall ceilings, kitchen appliances, tile backsplashes, deep sinks, walk-in closets, and in-home washer/dryer convenience in select homes create a polished, practical backdrop.</p><p>Beyond your front door, the community keeps your routine moving with a <a href=\"/amenities\">resort-style pool</a>, fitness center, cyber cafe, grill area, dog park, package lockers, online resident services, valet trash, and EV charging stations. When you head out, you’re close to the Clear Springs area’s country-road character and longtime favorites like Clear Springs Restaurant, with New Braunfels Plaza and Freiheit shopping nearby.</p><p>Spend free time exploring the spring-fed Comal River, Landa Park’s oak-shaded trails, Schlitterbahn, Downtown New Braunfels, and the live-music energy of Gruene Historic District—all part of the <a href=\"/neighborhood\">New Braunfels lifestyle</a> just beyond home.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-c2f0-7619-9550-9b317b4e179e.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and a waterfall feature, with apartment buildings in the background.",
    "public_id": "019f1a6f-c2f0-7619-9550-9b317b4e179e",
    "storage_key": "property/5767618778628096/019f1a6f-c2f0-7619-9550-9b317b4e179e.webp",
    "width": 3072,
    "height": 2300
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "276",
  "property_year_built": "2021",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.3913043478261",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee: $75\nAdministrative Fee: $150\nApplication Approval Fee: Starting at $300\nPet Fee: $300/pet\nMonthly Pet Rent: $25/pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8879191.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://clearsprings.loftliving.com/login",
  "property_apply_now_url": "https://8879191.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019e4d0c-2255-723b-9933-b6e73993bcdb.webp",
  "property_primary_logo_media": {
    "alt_text": "Clear Springs Premier Apartments logo",
    "public_id": "019e4d0c-2255-723b-9933-b6e73993bcdb",
    "storage_key": "property/5767618778628096/019e4d0c-2255-723b-9933-b6e73993bcdb.webp",
    "width": 1020,
    "height": 950
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019d02f5-2a80-704f-b38b-66db5691b814.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02f5-2a80-704f-b38b-66db5691b814",
    "storage_key": "property/5767618778628096/019d02f5-2a80-704f-b38b-66db5691b814.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019e4d0b-f559-76b9-8545-e52bab63181a.webp",
  "property_icon_media": {
    "alt_text": "Property logo with concentric blue arcs on a dark blue background.",
    "public_id": "019e4d0b-f559-76b9-8545-e52bab63181a",
    "storage_key": "property/5767618778628096/019e4d0b-f559-76b9-8545-e52bab63181a.webp",
    "width": 649,
    "height": 649
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019e4d0b-f559-76b9-8545-e52bab63181a.webp",
  "property_fav_icon_media": {
    "alt_text": "Property logo with concentric blue arcs on a dark blue background.",
    "public_id": "019e4d0b-f559-76b9-8545-e52bab63181a",
    "storage_key": "property/5767618778628096/019e4d0b-f559-76b9-8545-e52bab63181a.webp",
    "width": 649,
    "height": 649
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f152d-755f-7649-a59f-d3361ec3e735.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f152d-755f-7649-a59f-d3361ec3e735",
    "storage_key": "property/5767618778628096/019f152d-755f-7649-a59f-d3361ec3e735.webp",
    "width": 1020,
    "height": 950
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f152d-6a07-7589-9fca-fb5048b17a25.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f152d-6a07-7589-9fca-fb5048b17a25",
    "storage_key": "property/5767618778628096/019f152d-6a07-7589-9fca-fb5048b17a25.webp",
    "width": 1020,
    "height": 950
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#6ba3b9",
  "property_secondary_color": "#182752",
  "property_font_color": "#2e2a25",
  "property_color_4": "#1c519e",
  "property_color_3": "#457abb",
  "property_color_5": "#193d6c",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "499 - 937",
  "property_sqft_min": "499",
  "property_sqft_max": "937",
  "property_price_range": "797.5 - 1315",
  "property_price_min": "797.5",
  "property_price_max": "1315",
  "property_available_units": 21,
  "property_facebook_url": "https://www.facebook.com/ClearSpringsApartments",
  "property_instagram_url": "https://www.instagram.com/clearspringsapartments",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJn_DhSHu8XIYR50Krav-q6KI",
  "property_youtube_url": "https://www.youtube.com/@ClearSpringsApartments",
  "property_yelp_url": "https://www.yelp.com/biz/clear-springs-new-braunfels",
  "property_tiktok_url": "https://www.tiktok.com/@clearspringsapartments",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Everyday ease, built in.</strong> Clear Springs brings the essentials close with a cyber cafe, fitness center, swimming pool, grill area, dog park, LUXER package lockers, EV charging stations, online resident services, and valet trash. Select apartments add hard-surface flooring, tall ceilings, tile backsplash, deep sinks, walk-in closets, washer/dryer convenience, and outdoor space—all in New Braunfels off TX-46.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at Clear Springs.</strong> Choose from streamlined one-bedroom layouts and spacious two-bedroom, two-bath apartments in New Braunfels, each designed with open living areas, well-equipped kitchens, hard-surface flooring, tall ceilings, and smart storage. Select homes add walk-in closets, in-home washer/dryer convenience, tile backsplashes, deep sinks, and outdoor space—so it’s easy to compare the details that make a floor plan feel right.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture Clear Springs in focus.</strong> Preview polished kitchens with stainless steel appliances, tile backsplashes, deep sinks, and crisp counters, plus bright living areas with tall ceilings and wood-style flooring. Then follow the gallery outdoors to the pool, grill area, dog park, fitness center, and cyber cafe with coffee bar—each snapshot offering a quick feel for everyday spaces in New Braunfels.</p>",
  "property_home_neighborhood_blurb": "<p><strong>TX-46 keeps New Braunfels close.</strong> Grab seafood at the original Clear Springs Restaurant, run errands near Creekside, or unwind at Fischer Park with trails, ponds, and Hill Country views. Downtown adds cafés, boutiques, live music, and river-town energy just a short drive from home.</p>",
  "property_home_reviews_blurb": "<p><strong>See what stands out at Clear Springs.</strong><br>Resident feedback brings the everyday experience into focus, from apartment living and community spaces to service interactions and the New Braunfels setting. Browse the highlights, then read the full reviews to get a clearer feel for life at Clear Springs before you plan your visit.</p>",
  "property_neighborhood_blurb": "<p><strong>Your map starts with options close by.</strong> From Clear Springs, TX-46 puts the day within easy reach: casual seafood at the original Clear Springs Restaurant, errands around Creekside and nearby retail corridors, and green space at Fischer Park with trails, ponds, and wide Hill Country views. When you want a more local-feeling outing, head toward downtown New Braunfels for cafés, boutiques, live music, and the river-town energy that gives the city its character. Back at home, the community’s <a href=\"/amenities\">everyday amenities</a> make it simple to reset before the next stop—whether that means a pool break, a fitness session, or time outside with your pet.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces that keep daily details simple.</strong> At Clear Springs, your routine can move from a coffee-and-email stop in the cyber cafe to a workout in the fitness center, a swim at the pool, or dinner outside at the grill area—all without leaving the community.</p><p>Convenience is built in, too: LUXER package lockers help keep deliveries organized, EV charging stations support plug-in vehicles, and online resident services plus valet trash streamline the small tasks that add up. Inside, select homes add the polish renters look for in New Braunfels apartments, including hard-surface flooring, tall ceilings, tile backsplash, deep sinks, walk-in closets, washer/dryer convenience, and outdoor space. Bring your pet to the dog park, browse the <a href=\"/gallery\">amenity photos</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Clear Springs works in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Clear Springs home?</strong> Start your online application today and step into modern New Braunfels living with one- and two-bedroom layouts, polished in-home finishes, and everyday conveniences designed to keep life moving along TX-46.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the Clear Springs leasing team for help finding your way to our TX-46 location in New Braunfels, learning more about one- and two-bedroom layouts, or getting details on everyday conveniences designed to keep life moving.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Clear Springs?</strong> Start here for quick answers about the community, leasing, apartment features, and everyday living along TX-46 in New Braunfels. If you need more detail or want help with next steps, the leasing team is happy to assist.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the space that fits how you live.</strong> Clear Springs keeps the floor plan search simple with one- and two-bedroom apartments in New Braunfels, from efficient one-bath layouts to roomier two-bedroom, two-bath designs. Each option gives you a practical foundation for everyday routines, with open living areas, well-equipped kitchens, hard-surface flooring, tall ceilings, and storage-minded details like walk-in closets in select homes.</p><p>Compare current pricing and availability, then look for the finishing touches that matter most to you: in-home washer/dryer convenience in select homes, tile backsplashes, deep sinks, and outdoor space options that extend your living area. Browse the layouts below, explore the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite plan in person.</p>",
  "property_gallery_blurb": "<p><strong>See the details come into focus.</strong> Browse the Clear Springs photo gallery for a closer look at crisp, modern interiors and easygoing outdoor spaces in New Braunfels. Picture a kitchen with polished counters, stainless steel appliances, a tile backsplash, and a deep sink; a living area brightened by tall ceilings and wood-style flooring; or a patio or balcony that adds fresh air to your floor plan.</p><p>Beyond the apartment photos, follow the view to the pool, fitness center, cyber cafe with coffee bar, grill area, and dog park—scenes that show how the community feels from morning errands to unhurried evenings. When a favorite image catches your eye, compare <a href=\"/floor-plans\">available floor plans</a>, explore the <a href=\"/amenities\">amenity details</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Clear Springs in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Clear Springs on the map.</strong> See available <a href=\"/floor-plans\">one- and two-bedroom layouts</a> along TX-46, then zoom out to nearby shopping, dining, country-road scenery, and New Braunfels destinations that keep everyday plans close to home.</p>",
  "property_pets_blurb": "<p><strong>Room to wag, stretch, and settle in.</strong> Clear Springs makes pet-friendly apartment living in New Braunfels feel easy, with cats and dogs welcome and an on-site dog park for off-leash play between outings. Hard-surface flooring helps with quick cleanups, while select homes with patios or balconies give you and your companion a little extra fresh-air space.</p><p>From morning leash breaks to evening fetch sessions, the community is set up for everyday pet ownership without extra fuss. Compare layouts for the right amount of room, then explore the <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the dog park and outdoor spaces in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share Clear Springs with a friend.</strong><br>From polished one- and two-bedroom layouts to everyday conveniences and Hill Country momentum along TX-46, there’s plenty to pass along. Invite a friend to see what makes Clear Springs feel connected, comfortable, and easy to call home.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made easy.</strong> Keep everyday living at Clear Springs moving with online resident services designed for quick account management. Log in to pay rent, submit maintenance requests, and stay connected to your home along TX-46 in New Braunfels.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, right where it matters.</strong><br>As you compare Clear Springs, resident reviews can give you a closer look at the everyday experience behind the photos and details. Browse the ratings below to hear firsthand perspectives on apartment living, community spaces, service interactions, and the New Braunfels setting—so you can decide what stands out most to you. When you’re ready, plan a visit to experience Clear Springs in person.</p>",
  "property_created_at": "1752256751396",
  "property_scheduletour_blurb": "<p><strong>See Clear Springs in person.</strong> Tour one- and two-bedroom apartments with tall ceilings, hard-surface flooring, polished kitchen finishes, and everyday conveniences in select homes. Then picture your routine with community spaces designed to keep things moving. Schedule your tour today and get a closer look.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Clear Springs’ leasing team will follow up soon. In the meantime, picture easy everyday living along TX-46 with polished one- and two-bedroom layouts, modern finishes, and community spaces designed to keep your routine moving in New Braunfels.</p>",
  "property_virtualtours_blurb": "<p><strong>Step into the scene before you arrive.</strong> Clear Springs’ virtual Community Tour gives you a from-anywhere look at the shared spaces that shape the experience here, from the pool deck and fitness center to the cyber cafe, grill area, and dog park. Move at your own pace, pause on the details, and get a clearer feel for how the <a href=\"/amenities\">community amenities</a> connect across the property.</p><p>After the walkthrough, compare one- and two-bedroom <a href=\"/floor-plans\">floor plans</a>, browse more photos, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Clear Springs in New Braunfels up close.</p>",
  "property_copyright": "2025 All Rights Reserved. Clear Springs",
  "property_seo_title_home": "Clear Springs | Apartments in New Braunfels, TX",
  "property_seo_description_home": "Discover Clear Springs, your ideal apartment community in New Braunfels, TX! Explore our spacious One and Two Bedroom floor plans, featuring luxurious amenities like a dog park, fitness center, and resort-style pool. Enjoy convenience with LUXER Package Lockers, car charging stations, and online resident services. Experience the perfect blend of comfort and community with tall ceilings, hard floors, and walk-in closets. Find your new home today and elevate your lifestyle at Clear Springs!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in New Braunfels, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Clear Springs in beautiful New Braunfels, TX! Explore our thoughtfully designed floor plans, featuring spacious one-bedroom and two-bedroom apartments. Browse our available apartment homes today and find the perfect fit for your lifestyle!",
  "property_seo_title_amenities": "Amenities | New Braunfels, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover your perfect home at Clear Springs in New Braunfels, TX! Choose from spacious one or two-bedroom floor plans, featuring luxurious amenities like a state-of-the-art fitness center, a refreshing pool, and a convenient dog park. Enjoy modern living with hard floors, tile backsplashes, walk-in closets, and essential kitchen appliances—plus online resident services! Explore our amazing community amenities and apartment features today. ",
  "property_seo_title_gallery": "Gallery | Apartments in New Braunfels, TX",
  "property_seo_description_gallery": "Discover your dream home at Clear Springs in New Braunfels, TX! Explore our stunning photo gallery showcasing stylish one and two-bedroom floor plans, luxurious amenities like a fitness center, pool, dog park, and more. Enjoy the convenience of online resident services, valet trash, and LUXER package lockers. Picture yourself living here and experience modern living with tall ceilings, walk-in closets, and kitchen appliances included. Don’t miss out on your perfect apartment—view all our photo highlights today!",
  "property_seo_title_virtualtours": "Virtual Tours | Clear Springs Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Clear Springs in New Braunfels, TX! Explore our diverse floor plans, featuring spacious one and two-bedroom apartments ideal for your lifestyle. Ready to see it all? Take a virtual tour of our community and apartments for rent today!",
  "property_seo_title_interactivemap": "Interactive Map | Clear Springs Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Clear Springs in New Braunfels, TX! Explore spacious one and two-bedroom floor plans featuring modern amenities like a fitness center, dog park, and a relaxing pool. Enjoy conveniences such as LUXER package lockers, valet trash service, and online resident services. Use our interactive community map to view available apartments, pricing, and select your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in New Braunfels, TX",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Clear Springs in New Braunfels, TX! Explore our diverse one and two-bedroom floor plans while uncovering local favorites and essential points of interest nearby. See what's around our community and start your journey toward your new home today!",
  "property_seo_title_contact": "Contact Us | Clear Springs",
  "property_seo_description_contact": "Discover your ideal living space at Clear Springs in New Braunfels, TX! Explore our diverse floor plans, including stylish one and two-bedroom apartments tailored for your comfort. Have questions? Contact our leasing team today to learn more about making Clear Springs your new home!",
  "property_seo_title_faqs": "FAQs | Apartments in New Braunfels, TX",
  "property_seo_description_faqs": "Discover your ideal home at Clear Springs in New Braunfels, TX! Explore our diverse floor plans, including elegant one- and two-bedroom apartments designed for comfort and convenience. Enjoy a wealth of amenities like a state-of-the-art fitness center, dog park, pool, and LUXER package lockers. With online resident services and valet trash, your lifestyle is made easy. Have questions? Browse our FAQs page for all the answers about living in our vibrant community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in New Braunfels, TX",
  "property_seo_description_reviews": "Discover the vibrant community at Clear Springs in New Braunfels, TX! Explore our thoughtfully designed one and two-bedroom floor plans featuring modern amenities like a dog park, fitness center, and pool. With conveniences such as online resident services and valet trash service, life at Clear Springs is both comfortable and enjoyable. Don’t just take our word for it—see what our residents have to say about their experience living here! Join us today and find your perfect home!",
  "property_seo_title_applynow": "Apply Now | Apartments in New Braunfels, TX",
  "property_seo_description_applynow": "Discover your perfect oasis at Clear Springs in New Braunfels, TX! Choose from spacious one and two-bedroom floor plans that cater to your lifestyle. Enjoy top-notch amenities like a state-of-the-art fitness center, relaxing pool, convenient LUXER package locker, and a dog park for your furry friends. With features like hard floors, tall ceilings, walk-in closets, and modern kitchen appliances, your new home awaits. Don’t miss out—find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Clear Springs",
  "property_seo_description_residentaccess": "\"Welcome to Clear Springs in New Braunfels, TX! Access your resident portal to pay rent, schedule maintenance, and enjoy seamless community living. Log in now for convenience at your fingertips!\"",
  "property_seo_title_referafriend": "Refer A Friend | Clear Springs",
  "property_seo_description_referafriend": "\"Refer a friend to Clear Springs, your premier apartment community in New Braunfels, TX! Enjoy the benefits of great neighbors and exclusive rewards. Great friends make great neighbors—start sharing the joy of Clear Springs today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Clear Springs",
  "property_seo_description_scheduletour": "\"Discover your new home at Clear Springs in New Braunfels, TX! Schedule a tour today to explore our stunning apartments and beautiful community features. Your dream living experience awaits!\"",
  "property_seo_title_privacy": "Privacy Policy | Clear Springs",
  "property_seo_description_privacy": "\"Discover Clear Springs in New Braunfels, TX, where your privacy is our priority. Learn how we protect your personal information and ensure a secure living experience. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Clear Springs",
  "property_seo_description_accessibility": "Discover Clear Springs in New Braunfels, TX, where we prioritize digital inclusion for all. Our Accessibility Statement outlines our commitment to providing a seamless online experience. Explore our community today and see how we ensure everyone can easily access the information they need. Visit us now!",
  "property_seo_title_sitemap": "Sitemap | Clear Springs",
  "property_seo_description_sitemap": "Discover the layout and offerings of Clear Springs in New Braunfels, TX, with our comprehensive sitemap. Explore our vibrant community, amenities, and apartment options. Click now to navigate your future home!",
  "property_seo_title_thankyou": "Thank You | Clear Springs",
  "property_seo_description_thankyou": "Thank you for reaching out to Clear Springs in beautiful New Braunfels, TX! Your information has been received, and a member of our friendly team will be in touch shortly to assist you. Stay tuned for exciting updates about your future home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Buford, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319571",
  "amenities": [
    {
      "id": "custom_10def092-f159-4e96-a993-4035382a6c27",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_42dec3c6-ac7e-485a-a3ef-c2011cf359d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02c5983d-63da-41af-9b14-79e4bc5a8435",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "Electric Car Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c631231-b7c7-4bc8-b67a-3732188099bd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b1098738-e40e-4541-8b6c-0c185a5b01e3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_944d0448-5a30-4952-941e-5711afeeec86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab1e2fee-9fd8-4fa8-a568-918e21e5fd29",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Outdoor Grilling Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9bd5200e-43b8-4405-994e-9b9d0b78366c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_db28e26c-49fc-4650-a8ee-aed0623acd9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e8abb425-2804-495f-a94e-36a82f327734",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_909396a9-a1bb-47da-8eca-a263035eacb9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e5242a1e-2770-4218-a7c6-7dbf4068d983",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5319814d-cff0-4600-8cf6-a8f876575312",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6a68104b-c9ed-4121-a6d0-43b177b21903",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000676",
      "title": "Sink",
      "amount": "0.0000",
      "description": "Deep Kitchen Sinks w/ Gooseneck Faucets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6ec41736-910e-40ae-99d9-88ec64e73a2f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9` Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95ac833f-167e-4a69-862a-cac820d4a7a3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d0a140b-b877-4786-a42d-d313375dff30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5b667746-3f0d-4391-9303-4139b42f52d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fff82ab8-7962-4215-94c6-3fd8832aefe8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000002384",
      "title": "Cyber Cafe",
      "amount": "0.0000",
      "description": "Cyber Cafe w/ Coffee Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6bcfcc12-0e61-4e6c-b62c-43faa7c72747",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "external_id": "P000002458",
      "title": "Valet Trash Service",
      "amount": "0.0000",
      "description": "Valet Trash Service",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_f722005d-afd2-4b6c-b4cd-94931a3836a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-c644-76db-92dc-f4de938068fe.webp",
      "image_media": {
        "alt_text": "Exterior of an apartment building with a fenced-in dog park and playground.",
        "public_id": "019f1a6f-c644-76db-92dc-f4de938068fe",
        "storage_key": "property/5767618778628096/019f1a6f-c644-76db-92dc-f4de938068fe.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Modern apartment building featuring an on-site dog park and playground, perfect for pets and families.",
      "link": "",
      "alt_text": "Exterior of an apartment building with a fenced-in dog park and playground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bb4388ff-91d2-4d16-ad87-3eca995dded2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-cf83-7468-9512-d7b6bd6b363e.webp",
      "image_media": {
        "alt_text": "Closet with shelves and hanging rods",
        "public_id": "019f1a6f-cf83-7468-9512-d7b6bd6b363e",
        "storage_key": "property/5767618778628096/019f1a6f-cf83-7468-9512-d7b6bd6b363e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space.",
      "link": "",
      "alt_text": "Closet with shelves and hanging rods",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_107b11f6-2010-49ee-af16-77b45d799730",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-f652-7256-8542-c27f02a86202.webp",
      "image_media": {
        "alt_text": "Modern dining area with marble-top table and plush burgundy chairs.",
        "public_id": "019f1a6f-f652-7256-8542-c27f02a86202",
        "storage_key": "property/5767618778628096/019f1a6f-f652-7256-8542-c27f02a86202.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy meals in this stylish dining area, featuring a sleek marble-top table and comfortable, plush burgundy chairs. Perfect for intimate dinners or entertaining guests.",
      "link": "",
      "alt_text": "Modern dining area with marble-top table and plush burgundy chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bc40b103-aa88-46fd-b223-16c616c508d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-ff35-704a-a3f8-2bbc69ba1654.webp",
      "image_media": {
        "alt_text": "Clear Springs Premier Apartments smart package lockers with the property logo and a digital screen.",
        "public_id": "019f1a6f-ff35-704a-a3f8-2bbc69ba1654",
        "storage_key": "property/5767618778628096/019f1a6f-ff35-704a-a3f8-2bbc69ba1654.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Secure and convenient package lockers for residents, featuring the Clear Springs Premier Apartments logo.",
      "link": "",
      "alt_text": "Clear Springs Premier Apartments smart package lockers with the property logo and a digital screen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b6a50ae6-b390-4733-a98a-53fc50d13935",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-fa1d-77cf-b670-3d850556f536.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and weight machines.",
        "public_id": "019f1a6f-fa1d-77cf-b670-3d850556f536",
        "storage_key": "property/5767618778628096/019f1a6f-fa1d-77cf-b670-3d850556f536.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a variety of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_29924dac-71f9-4495-845b-0079e5930554",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-f83d-76ad-a31d-e3cf3ff21dc5.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019f1a6f-f83d-76ad-a31d-e3cf3ff21dc5",
        "storage_key": "property/5767618778628096/019f1a6f-f83d-76ad-a31d-e3cf3ff21dc5.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool, surrounded by comfortable lounge chairs and vibrant umbrellas, perfect for relaxation and recreation.",
      "link": "",
      "alt_text": "Aerial view of an apartment complex with a large swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_61c60d0f-1e3c-46ab-bdaa-53fc5ec95836",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-f46c-771e-8045-2b1051c91592.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, granite countertops, and a bathtub with shower.",
        "public_id": "019f1a6f-f46c-771e-8045-2b1051c91592",
        "storage_key": "property/5767618778628096/019f1a6f-f46c-771e-8045-2b1051c91592.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, ample cabinet storage, and a bathtub with a shower.",
      "link": "",
      "alt_text": "Bathroom with double vanity, granite countertops, and a bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ad57f966-c307-491e-a85e-12cb7b34faf1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-c118-716c-90c9-da957fbebff0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with blue lounge chairs and surrounding apartment buildings.",
        "public_id": "019f1a6f-c118-716c-90c9-da957fbebff0",
        "storage_key": "property/5767618778628096/019f1a6f-c118-716c-90c9-da957fbebff0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. A perfect oasis for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with blue lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0b266126-50f8-47db-9e01-feabec7cf106",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-fca1-76ea-99cd-5ee2013298fa.webp",
      "image_media": {
        "alt_text": "Living and dining area with modern furniture and art.",
        "public_id": "019f1a6f-fca1-76ea-99cd-5ee2013298fa",
        "storage_key": "property/5767618778628096/019f1a6f-fca1-76ea-99cd-5ee2013298fa.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Stylish living and dining area featuring comfortable seating, a dining table for four, and contemporary wall art, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living and dining area with modern furniture and art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_364e96c9-ed3f-40a1-938d-f255033b7ed1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-c363-77f7-83c3-02d0627d3897.webp",
      "image_media": {
        "alt_text": "Comfortable bedroom with a king-size bed, plush bedding, and tasteful decor.",
        "public_id": "019f1a6f-c363-77f7-83c3-02d0627d3897",
        "storage_key": "property/5767618778628096/019f1a6f-c363-77f7-83c3-02d0627d3897.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this beautifully appointed bedroom, featuring a luxurious king-size bed and elegant design elements.",
      "link": "",
      "alt_text": "Comfortable bedroom with a king-size bed, plush bedding, and tasteful decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4a48fa90-838a-4df5-9255-56c03d0bddbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-e261-708d-9223-f0e654842fdb.webp",
      "image_media": {
        "alt_text": "Shuffleboard table in a game room with blue and red pucks",
        "public_id": "019f1a6f-e261-708d-9223-f0e654842fdb",
        "storage_key": "property/5767618778628096/019f1a6f-e261-708d-9223-f0e654842fdb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a game of shuffleboard in the community game room, perfect for resident entertainment and social gatherings.",
      "link": "",
      "alt_text": "Shuffleboard table in a game room with blue and red pucks",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_45217d92-a464-44f0-9c10-7e0458472a94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-c2f0-7619-9550-9b317b4e179e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a waterfall feature, with apartment buildings in the background.",
        "public_id": "019f1a6f-c2f0-7619-9550-9b317b4e179e",
        "storage_key": "property/5767618778628096/019f1a6f-c2f0-7619-9550-9b317b4e179e.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with a relaxing waterfall and ample lounge seating. Your perfect oasis awaits.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a waterfall feature, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae2b6a9c-cf45-40d0-961b-333b06afc29c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-cf1c-75e9-a5dc-aec0ef09892d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and breakfast bar with pink stools.",
        "public_id": "019f1a6f-cf1c-75e9-a5dc-aec0ef09892d",
        "storage_key": "property/5767618778628096/019f1a6f-cf1c-75e9-a5dc-aec0ef09892d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring dark wood cabinetry, sleek granite countertops, and a spacious breakfast bar. Perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and breakfast bar with pink stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8a8ac811-a6bd-4871-8483-33923fae4ebc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-c283-74ce-a518-4b0351bad43e.webp",
      "image_media": {
        "alt_text": "Stainless steel appliances and dark wood cabinets in a modern kitchen.",
        "public_id": "019f1a6f-c283-74ce-a518-4b0351bad43e",
        "storage_key": "property/5767618778628096/019f1a6f-c283-74ce-a518-4b0351bad43e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Chic kitchen featuring stainless steel appliances, dark wood cabinetry, and granite countertops.",
      "link": "",
      "alt_text": "Stainless steel appliances and dark wood cabinets in a modern kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c59270c6-d096-4ca3-8aae-1d9e9858298e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-c0f4-72ec-be9d-fea4fbdab15f.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, TV, and dining table.",
        "public_id": "019f1a6f-c0f4-72ec-be9d-fea4fbdab15f",
        "storage_key": "property/5767618778628096/019f1a6f-c0f4-72ec-be9d-fea4fbdab15f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, a modern coffee table, a wall-mounted TV, and a dining area with a marble-top table.",
      "link": "",
      "alt_text": "Living room with sofa, coffee table, TV, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_31926cbd-b515-4314-96dc-169b337ef358",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-c50b-76fb-ab4b-92b1b0069fc9.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, stationary bikes, and weight machines.",
        "public_id": "019f1a6f-c50b-76fb-ab4b-92b1b0069fc9",
        "storage_key": "property/5767618778628096/019f1a6f-c50b-76fb-ab4b-92b1b0069fc9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, stationary bikes, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9fb7b0c2-9b5a-4458-a77a-d53571d82d0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-c35c-7453-8b3e-56fae80e7fb3.webp",
      "image_media": {
        "alt_text": "Coffee station with Keurig machine, cups, and snacks",
        "public_id": "019f1a6f-c35c-7453-8b3e-56fae80e7fb3",
        "storage_key": "property/5767618778628096/019f1a6f-c35c-7453-8b3e-56fae80e7fb3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and snacks at our convenient coffee station.",
      "link": "",
      "alt_text": "Coffee station with Keurig machine, cups, and snacks",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_fc46c18eb16c177bdaf4e185",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Clear Springs Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1692 Hwy 46 W, New Braunfels, TX 78130, USA",
      "poi_short_description": "Restaurant plating seafood, steaks & signature onion rings in a vibrant, barnlike setting.",
      "poi_long_description": "Restaurant plating seafood, steaks & signature onion rings in a vibrant, barnlike setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150c-d7a6-70f9-9c31-1bdeef159fc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-d7a6-70f9-9c31-1bdeef159fc8",
        "storage_key": "property/5767618778628096/019f150c-d7a6-70f9-9c31-1bdeef159fc8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.clearspringsrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1361726733299127575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-springs-restaurant",
      "poi_latitude": "29.6770295",
      "poi_longitude": "-98.0605362",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 830-629-3775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtaqhxjS9XIYRF5Vyyz_T5RI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_d6f3c96f53ac5313a26a33db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "The Reel Seafood & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1683 TX-46 #235, New Braunfels, TX 78132, USA",
      "poi_short_description": "Popular seafood spot offering Cajun-style dishes & fried platters, plus a full bar & outdoor tables.",
      "poi_long_description": "Popular seafood spot offering Cajun-style dishes & fried platters, plus a full bar & outdoor tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150f-fd0c-7713-9372-ece9beda59cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-fd0c-7713-9372-ece9beda59cc",
        "storage_key": "property/5767618778628096/019f150f-fd0c-7713-9372-ece9beda59cc.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "http://www.reelseafoodhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14321940332249451099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-reel-seafood--grill",
      "poi_latitude": "29.7152488",
      "poi_longitude": "-98.1614774",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 830-214-6103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNRNdLIyXXIYRW4oR7tnAwcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_ff407faa2b00b034ebfff7ee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "McAlister's Deli",
      "poi_type": "Restaurants",
      "poi_address": "1680 State Hwy 46 W, New Braunfels, TX 78132, USA",
      "poi_short_description": "Easygoing counter-service chain known for its sandwiches, stuffed baked potatoes & sweet tea.",
      "poi_long_description": "Easygoing counter-service chain known for its sandwiches, stuffed baked potatoes & sweet tea.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-0538-7452-90a3-91ebb8bed2cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-0538-7452-90a3-91ebb8bed2cf",
        "storage_key": "property/5767618778628096/019f1510-0538-7452-90a3-91ebb8bed2cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.mcalistersdeli.com/tx/new-braunfels/1680-state-highway-46-w?utm_source=google&utm_medium=organic&utm_campaign=locations_partner",
      "poi_directions_map_url": "https://maps.google.com/?cid=15909626352288793309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcalisters-deli",
      "poi_latitude": "29.7169662",
      "poi_longitude": "-98.1596681",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 830-358-5166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4XWZZoyXXIYR3QJe5d9Yytw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_0181b81542024be2cf91a8ee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "1687 TX-46, New Braunfels, TX 78132, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-021b-7610-946c-832a46e89a53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-021b-7610-946c-832a46e89a53",
        "storage_key": "property/5767618778628096/019f1510-021b-7610-946c-832a46e89a53.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://locations.whataburger.com/tx/new-braunfels/1687-sh-46-e.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=9419086638779735912&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "29.7160704",
      "poi_longitude": "-98.160314",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 830-608-1447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgyBso3q8XIYRaB8YvWRRt4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_df868e53b29820c5fc3fbe1d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "McDonald's",
      "poi_type": "Restaurants",
      "poi_address": "1761 State Hwy 46 W, New Braunfels, TX 78132, USA",
      "poi_short_description": "Classic, long-running fast-food chain known for its burgers & fries.",
      "poi_long_description": "Classic, long-running fast-food chain known for its burgers & fries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150f-fea3-731b-a5a9-2ab508f7d8c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-fea3-731b-a5a9-2ab508f7d8c6",
        "storage_key": "property/5767618778628096/019f150f-fea3-731b-a5a9-2ab508f7d8c6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mcdonalds.com/us/en-us/location/TX/NEW-BRAUNFELS/1761-STATE-HWY-46-W/34984.html?cid=RF:YXT:GMB::Clicks",
      "poi_directions_map_url": "https://maps.google.com/?cid=17160838574269450492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcdonalds",
      "poi_latitude": "29.717787",
      "poi_longitude": "-98.162278",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 830-620-1112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGzag-XC8XIYR_Mgm48KLJ-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_5df90f993b761df7f59b60f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Smokey Mo's BBQ",
      "poi_type": "Restaurants",
      "poi_address": "1862 TX-46 Ste 103, New Braunfels, TX 78132, USA",
      "poi_short_description": "Local chain serving barbecued meats & sides (plus breakfast) in a no-frills, counter-serve setting.",
      "poi_long_description": "Local chain serving barbecued meats & sides (plus breakfast) in a no-frills, counter-serve setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150f-fcdf-75bf-b830-5688e55a9978.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-fcdf-75bf-b830-5688e55a9978",
        "storage_key": "property/5767618778628096/019f150f-fcdf-75bf-b830-5688e55a9978.webp",
        "width": 1280,
        "height": 880
      },
      "poi_business_url": "https://smokeymosbbq.com/locations/sanantonio/new-braunfels/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9894032840477529659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smokey-mos-bbq",
      "poi_latitude": "29.72012939999999",
      "poi_longitude": "-98.1650509",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 830-837-5412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyyo1CYmXXIYRO1a2lHKqTok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_0deda36e8a26d4ada015a620",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Las Palapas - West Point Village",
      "poi_type": "Restaurants",
      "poi_address": "1675 State Hwy 46 W, New Braunfels, TX 78132, USA",
      "poi_short_description": "Texas-style Mexican eatery featuring breakfast, tacos, burgers, fajitas, queso and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-0035-76cc-a4fe-8c96716f8b06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-0035-76cc-a4fe-8c96716f8b06",
        "storage_key": "property/5767618778628096/019f1510-0035-76cc-a4fe-8c96716f8b06.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://laspalapas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=660532532128777102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "las-palapas---west-point-village",
      "poi_latitude": "29.7156527",
      "poi_longitude": "-98.159911",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 830-302-2301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvUbbTEGXXIYRjgMgnNauKgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_ef6b0693311c2b06775d2a8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Stout's Pizza Co.",
      "poi_type": "Restaurants",
      "poi_address": "1850 TX-46 Ste 101, New Braunfels, TX 78132, USA",
      "poi_short_description": "Counter-order pizza shop, also serving salads and doughy calzones.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-00fb-7713-abe7-4ae884d943d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-00fb-7713-abe7-4ae884d943d3",
        "storage_key": "property/5767618778628096/019f1510-00fb-7713-abe7-4ae884d943d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stoutspizzaco.com/san-antonio-menu",
      "poi_directions_map_url": "https://maps.google.com/?cid=16871779925658956713&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stouts-pizza-co",
      "poi_latitude": "29.7198744",
      "poi_longitude": "-98.1640808",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 830-302-7204",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIWhTUoiXXIYRqfN3rXOaJOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_8e3b29c039469aa91e5ace37",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Einstein Bros. Bagels",
      "poi_type": "Restaurants",
      "poi_address": "156 TX-46 Ste 100, New Braunfels, TX 78130, USA",
      "poi_short_description": "Neighborhood bakery chain specializing in freshly baked bagels and breakfast sandwiches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-04ce-70e7-9fe8-bf2c9f83b5a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-04ce-70e7-9fe8-bf2c9f83b5a3",
        "storage_key": "property/5767618778628096/019f1510-04ce-70e7-9fe8-bf2c9f83b5a3.webp",
        "width": 1280,
        "height": 1177
      },
      "poi_business_url": "https://locations.einsteinbros.com/us/tx/new-braunfels/156-s-state-highway-46?y_source=1_OTA0OTYzOC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14777200049090033204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "einstein-bros-bagels",
      "poi_latitude": "29.7009177",
      "poi_longitude": "-98.0955264",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 830-358-5055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR_qWtRi9XIYRNHbl1CYpE80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "ec_fdeb73d6820023e6711f140a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Dunkin'",
      "poi_type": "Restaurants",
      "poi_address": "599 TX-46 Suite 101, New Braunfels, TX 78130, USA",
      "poi_short_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_long_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-0339-73a0-9bc1-4b01151f204b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-0339-73a0-9bc1-4b01151f204b",
        "storage_key": "property/5767618778628096/019f1510-0339-73a0-9bc1-4b01151f204b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.dunkindonuts.com/en/tx/new-braunfels/599-s-state-highway-46/355430?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=355430&y_source=1_MTIxMTM3MzQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15346736040715320890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dunkin",
      "poi_latitude": "29.6980093",
      "poi_longitude": "-98.0902445",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 830-625-2077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-46c5-73d1-b247-53ad022edba6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-46c5-73d1-b247-53ad022edba6",
        "storage_key": "property/5767618778628096/019f1510-46c5-73d1-b247-53ad022edba6.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJlzVzAB69XIYROn6FWB6P-tQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_41fd9a4f4e82cfb8de5c2dee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Sonic Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "716 TX-46, New Braunfels, TX 78130, USA",
      "poi_short_description": "Fast-food burger & fries joint with an old-school feel, including retro drive-in service.",
      "poi_long_description": "Fast-food burger & fries joint with an old-school feel, including retro drive-in service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150f-ffca-777b-9688-6fb70cd8935a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-ffca-777b-9688-6fb70cd8935a",
        "storage_key": "property/5767618778628096/019f150f-ffca-777b-9688-6fb70cd8935a.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.sonicdrivein.com/locations/us/tx/new-braunfels/716-state-highway-46-south/store-6476?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAzMzg1OTIzMC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3831168912183568505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sonic-drive-in",
      "poi_latitude": "29.6963117",
      "poi_longitude": "-98.0892417",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 830-625-2811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJadoJD-K8XIYReag4xdMLKzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_9d2f1e28b7ce330c8cc9f9cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Naegelin's German Bakery",
      "poi_type": "Restaurants",
      "poi_address": "129 S Seguin Ave, New Braunfels, TX 78130, USA",
      "poi_short_description": "Dating to 1868, this bakery turns out pies, strudel & custom cakes in a bright, basic setting.",
      "poi_long_description": "Dating to 1868, this bakery turns out pies, strudel & custom cakes in a bright, basic setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-04e0-70fe-b27f-297d6f4f35c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-04e0-70fe-b27f-297d6f4f35c2",
        "storage_key": "property/5767618778628096/019f1510-04e0-70fe-b27f-297d6f4f35c2.webp",
        "width": 533,
        "height": 400
      },
      "poi_business_url": "http://naegelins.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17590963899458327959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "naegelins-german-bakery",
      "poi_latitude": "29.7026611",
      "poi_longitude": "-98.1239072",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-625-5722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJowfeQ129XIYRlxXvM3eoH_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_f88b438e21efc7b3ff78d3d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Krause's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "148 S Castell Ave, New Braunfels, TX 78130, USA",
      "poi_short_description": "Lively beer garden & taproom with beers, wines & margaritas on tap, plus American & German fare.",
      "poi_long_description": "Lively beer garden & taproom with beers, wines & margaritas on tap, plus American & German fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150c-d923-733e-b747-34023e1aed65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-d923-733e-b747-34023e1aed65",
        "storage_key": "property/5767618778628096/019f150c-d923-733e-b747-34023e1aed65.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.krausescafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6720415583914850961&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "krauses-cafe",
      "poi_latitude": "29.7013856",
      "poi_longitude": "-98.1249258",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-625-2807",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf9Yxhme9XIYRkXo-Bl62Q10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "german_restaurant"
    },
    {
      "id": "ec_3b74519f30db3437a5bc3f9d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Gristmill River Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "1287 Gruene Rd, New Braunfels, TX 78130, USA",
      "poi_short_description": "Chicken-fried steak, burgers & ribs served in an 1878 cotton gin with a shady patio & river views.",
      "poi_long_description": "Chicken-fried steak, burgers & ribs served in an 1878 cotton gin with a shady patio & river views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150c-de29-7138-ab78-6d17c142cd34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-de29-7138-ab78-6d17c142cd34",
        "storage_key": "property/5767618778628096/019f150c-de29-7138-ab78-6d17c142cd34.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://gristmillrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10659667145605406025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gristmill-river-restaurant--bar",
      "poi_latitude": "29.738203",
      "poi_longitude": "-98.105163",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 830-625-0684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQy10k8WiXIYRSV22pcq-7pM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_068a1f0b1432986960dc25e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Huisache Grill",
      "poi_type": "Restaurants",
      "poi_address": "303 W San Antonio St, New Braunfels, TX 78130, USA",
      "poi_short_description": "Quaint bistro serving regionally inspired menu plus beer & wine in a cozy space with exposed beams.",
      "poi_long_description": "Quaint bistro serving regionally inspired menu plus beer & wine in a cozy space with exposed beams.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-073b-76eb-ace1-982c79e5e127.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-073b-76eb-ace1-982c79e5e127",
        "storage_key": "property/5767618778628096/019f1510-073b-76eb-ace1-982c79e5e127.webp",
        "width": 929,
        "height": 613
      },
      "poi_business_url": "http://huisachegrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15402182705875932805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huisache-grill",
      "poi_latitude": "29.7003235",
      "poi_longitude": "-98.1260475",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-620-9001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBRXac2e9XIYRhVZmFZGLv9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_6f2d9ff11755fd571e0d6fad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "1655 TX-46, New Braunfels, TX 78130, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-06d5-728f-b4df-ddb37f453bc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-06d5-728f-b4df-ddb37f453bc8",
        "storage_key": "property/5767618778628096/019f1510-06d5-728f-b4df-ddb37f453bc8.webp",
        "width": 1109,
        "height": 610
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/new-braunfels/new-braunfels-h-e-b-at-hwy-46-74?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=11307261066084554578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.7130093",
      "poi_longitude": "-98.1603865",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 830-626-0937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b34-740c-b05d-f1de3b62f49e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b34-740c-b05d-f1de3b62f49e",
        "storage_key": "property/5767618778628096/019f150d-2b34-740c-b05d-f1de3b62f49e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5a81XoyXXIYRUheT-gd265w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_e145125729d484fbd82eecd1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Fischer's Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1677 TX-46, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-08d5-7726-a4da-b13bb7b49fb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-08d5-7726-a4da-b13bb7b49fb4",
        "storage_key": "property/5767618778628096/019f1510-08d5-7726-a4da-b13bb7b49fb4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fischersmkt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4131418534105496870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fischers-neighborhood-market",
      "poi_latitude": "29.6774754",
      "poi_longitude": "-98.0595751",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 830-627-4449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-46c4-7691-8318-f40c972f9361.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-46c4-7691-8318-f40c972f9361",
        "storage_key": "property/5767618778628096/019f1510-46c4-7691-8318-f40c972f9361.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJFcZyiaW9XIYRJr3Sf0S_VTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_67dd3fb557fe6d12cd8c0894",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "The Shops at Clear Springs",
      "poi_type": "Shopping & Retail",
      "poi_address": "1761 TX-46 South, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-0aa3-72db-a864-49b6824b3c4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-0aa3-72db-a864-49b6824b3c4c",
        "storage_key": "property/5767618778628096/019f1510-0aa3-72db-a864-49b6824b3c4c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8843835954676750515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-shops-at-clear-springs",
      "poi_latitude": "29.6752765",
      "poi_longitude": "-98.0581157",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b80-742a-ac3b-ca54954116e4",
        "storage_key": "property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_28Flni9XIYRs9hVsvGdu3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_49a2e25fb9aa093d37a33ae3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1610 State Hwy 46 W, New Braunfels, TX 78132, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-0aa7-76f5-a608-e1d1146be6d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-0aa7-76f5-a608-e1d1146be6d1",
        "storage_key": "property/5767618778628096/019f1510-0aa7-76f5-a608-e1d1146be6d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1610+state+highway+46+w-new+braunfels-tx-78132/id=10393",
      "poi_directions_map_url": "https://maps.google.com/?cid=2960251706703613184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.7155422",
      "poi_longitude": "-98.1577671",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 830-626-7142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjz9q8IyXXIYRAA3QPz7tFCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_2cd6577034a36f4e89dc9ba6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1910 State Hwy 46 W, New Braunfels, TX 78132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-0a41-720d-a901-f3ca1bb6488b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-0a41-720d-a901-f3ca1bb6488b",
        "storage_key": "property/5767618778628096/019f1510-0a41-720d-a901-f3ca1bb6488b.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/new-braunfels-tx-pharmacies/1910-state-highway-46-w-new-braunfels-tx-78132/storeid=10947?WT.mc_id=LS_GOOGLE_RX_10947",
      "poi_directions_map_url": "https://maps.google.com/?cid=17252362955929889824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.7204549",
      "poi_longitude": "-98.1666113",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 830-620-9926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-46c6-7439-afcb-57f54b68cbc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-46c6-7439-afcb-57f54b68cbc7",
        "storage_key": "property/5767618778628096/019f1510-46c6-7439-afcb-57f54b68cbc7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqquqZXIYRICxPlLO0bO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_02daaec168e1347d47942226",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "135 Creekside Way, New Braunfels, TX 78130, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-0994-747c-9c19-c03bd0e5d0dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-0994-747c-9c19-c03bd0e5d0dd",
        "storage_key": "property/5767618778628096/019f1510-0994-747c-9c19-c03bd0e5d0dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/new-braunfels/2429",
      "poi_directions_map_url": "https://maps.google.com/?cid=17503288484148258080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "29.7314651",
      "poi_longitude": "-98.0732885",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-608-3280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b80-742a-ac3b-ca54954116e4",
        "storage_key": "property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqTRr5jSjXIYRIKXX0iMs6PI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_b259baa1b49531ef5d18d3a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "257 Creekside Crossing, New Braunfels, TX 78130, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-0d0a-72ac-8bb9-05e78dc79379.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-0d0a-72ac-8bb9-05e78dc79379",
        "storage_key": "property/5767618778628096/019f1510-0d0a-72ac-8bb9-05e78dc79379.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dollartree.com/tx/new-braunfels/257-creekside-crossing?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=15203173454646030300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "29.7251284",
      "poi_longitude": "-98.0740899",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 830-369-0269",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b80-742a-ac3b-ca54954116e4",
        "storage_key": "property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1Wrxv6y9XIYR3C_TBrWF_NI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_44c3434528ce281b3995e3e2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "279 Creekside Way, New Braunfels, TX 78130, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150c-d293-724d-9322-86cb41346538.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-d293-724d-9322-86cb41346538",
        "storage_key": "property/5767618778628096/019f150c-d293-724d-9322-86cb41346538.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13923748549982939314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "29.7286927",
      "poi_longitude": "-98.0705805",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-620-9475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b80-742a-ac3b-ca54954116e4",
        "storage_key": "property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJe8zR6-ajXIYRsuiX94gXO8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_77a2b5280525d076015d46b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "187 Creekside Way, New Braunfels, TX 78130, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-0ca4-70c1-9264-1d4920e918cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-0ca4-70c1-9264-1d4920e918cc",
        "storage_key": "property/5767618778628096/019f1510-0ca4-70c1-9264-1d4920e918cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/tx/new-braunfels/187-creekside-wy-1387.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=5577286880198344179&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "29.7303427",
      "poi_longitude": "-98.0725151",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-643-6649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b80-742a-ac3b-ca54954116e4",
        "storage_key": "property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_UQQuTSjXIYR8z2rKN6AZk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "ec_5a69f8a9799ee395a22776b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1209 I-35, New Braunfels, TX 78130, USA",
      "poi_short_description": "Vast big-box retailer selling electronics and home furnishings in addition to toys, clothing, groceries, baked goods and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-0de2-77cb-8630-1a167e1eb176.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-0de2-77cb-8630-1a167e1eb176",
        "storage_key": "property/5767618778628096/019f1510-0de2-77cb-8630-1a167e1eb176.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/865-new-braunfels-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=526793312718668965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.6837045",
      "poi_longitude": "-98.1280528",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-629-0129",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b80-742a-ac3b-ca54954116e4",
        "storage_key": "property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaROWh9KXXIYRpcSlErqLTwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_76e3a44b1fc6b8090b067450",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Clear Spring Elementary School",
      "poi_type": "Education",
      "poi_address": "550 Avery Pkwy, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cses.comalisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10344324974722045692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-spring-elementary-school",
      "poi_latitude": "29.6677361",
      "poi_longitude": "-98.0449758",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 830-837-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b32-740f-bd4a-5cb17bfdd807",
        "storage_key": "property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgeKuFSC9XIYR_FaCB8Jsjo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_6eac9c90b9f22e30e61d2696",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Goodwin Frazier Elementary",
      "poi_type": "Education",
      "poi_address": "1441 S Business IH 35, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-0e8e-7589-bb00-aa41b0f1d97e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-0e8e-7589-bb00-aa41b0f1d97e",
        "storage_key": "property/5767618778628096/019f1510-0e8e-7589-bb00-aa41b0f1d97e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.comalisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8167912114180205647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goodwin-frazier-elementary",
      "poi_latitude": "29.7086449",
      "poi_longitude": "-98.0940886",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 830-221-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b32-740f-bd4a-5cb17bfdd807",
        "storage_key": "property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw3nPjmOkXIYRTyxS2spAWnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_10317884424fcc9f0e46327b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Freiheit Elementary School",
      "poi_type": "Education",
      "poi_address": "2002 FM1101, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-0fdb-7720-9049-c97a5969ab75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-0fdb-7720-9049-c97a5969ab75",
        "storage_key": "property/5767618778628096/019f1510-0fdb-7720-9049-c97a5969ab75.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fes.comalisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4915491215444883249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freiheit-elementary-school",
      "poi_latitude": "29.7085239",
      "poi_longitude": "-98.0776379",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 830-221-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b32-740f-bd4a-5cb17bfdd807",
        "storage_key": "property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd8WHOsS8XIYRMTclkTdVN0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_ae686f8f3975ea832967c65e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Oak Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "3060 Goodwin Ln, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-1157-747e-82cb-e645151d6224.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-1157-747e-82cb-e645151d6224",
        "storage_key": "property/5767618778628096/019f1510-1157-747e-82cb-e645151d6224.webp",
        "width": 1280,
        "height": 868
      },
      "poi_business_url": "https://oces.comalisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11900103086996363015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-creek-elementary-school",
      "poi_latitude": "29.7500709",
      "poi_longitude": "-98.0711531",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 830-837-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b32-740f-bd4a-5cb17bfdd807",
        "storage_key": "property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhVgWuzyjXIYRB5fySrWoJaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_90065fcea25e22b42de878db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Canyon Middle School",
      "poi_type": "Education",
      "poi_address": "2014 FM1101, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-10ef-7529-99d5-814c35685fc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-10ef-7529-99d5-814c35685fc7",
        "storage_key": "property/5767618778628096/019f1510-10ef-7529-99d5-814c35685fc7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cms.comalisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8177688097987229888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canyon-middle-school",
      "poi_latitude": "29.7122498",
      "poi_longitude": "-98.0732623",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 830-221-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b32-740f-bd4a-5cb17bfdd807",
        "storage_key": "property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSxN_vMa8XIYRwPh3dP_7fHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_ad5be43847faadc379e74efa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Canyon High School",
      "poi_type": "Education",
      "poi_address": "1510 I-35, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-11c4-711f-b227-75d4f16694af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-11c4-711f-b227-75d4f16694af",
        "storage_key": "property/5767618778628096/019f1510-11c4-711f-b227-75d4f16694af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://comalisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3102619675976530151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canyon-high-school",
      "poi_latitude": "29.7092358",
      "poi_longitude": "-98.0888997",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 830-221-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b32-740f-bd4a-5cb17bfdd807",
        "storage_key": "property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJycKQ8d68XIYR5_i3Kyi4Dis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_c84aa7df124aba0b2a4a2604",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "The Children's Courtyard on Hunters Village Drive",
      "poi_type": "Education",
      "poi_address": "241 Hunters Village, New Braunfels, TX 78132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-1278-7433-89a3-bcaead32296c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-1278-7433-89a3-bcaead32296c",
        "storage_key": "property/5767618778628096/019f1510-1278-7433-89a3-bcaead32296c.webp",
        "width": 711,
        "height": 400
      },
      "poi_business_url": "https://www.childrenscourtyard.com/your-local-school/new-braunfels-tx-3230/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=3230",
      "poi_directions_map_url": "https://maps.google.com/?cid=3667296169749196110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-childrens-courtyard-on-hunters-village-drive",
      "poi_latitude": "29.7193761",
      "poi_longitude": "-98.1712877",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 866-561-3412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b32-740f-bd4a-5cb17bfdd807",
        "storage_key": "property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV8Ydo1uXXIYRTi0NrG_a5DI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_80d5d6cef760b18c948c56d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Kids ‘R’ Kids Learning Academy of Westpointe",
      "poi_type": "Education",
      "poi_address": "2230 Independence Dr, New Braunfels, TX 78132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-14db-76fd-8e43-c40b5be3d7f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-14db-76fd-8e43-c40b5be3d7f2",
        "storage_key": "property/5767618778628096/019f1510-14db-76fd-8e43-c40b5be3d7f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kidsrkids.com/westpointe",
      "poi_directions_map_url": "https://maps.google.com/?cid=18278152693875597799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-r-kids-learning-academy-of-westpointe",
      "poi_latitude": "29.71243879999999",
      "poi_longitude": "-98.1643152",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 830-494-4554",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b32-740f-bd4a-5cb17bfdd807",
        "storage_key": "property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-XTDMaiXXIYR5-HNhAgLqf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_8f5d27da38e9f5c19a95cb26",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Brilliant Starts Learning Academy",
      "poi_type": "Education",
      "poi_address": "2101 FM1101, New Braunfels, TX 78130, USA",
      "poi_short_description": "Academy for preschoolers, kindergartners and babies, with learning-based curriculum.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-1425-71d4-a18a-32a5945bb6f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-1425-71d4-a18a-32a5945bb6f2",
        "storage_key": "property/5767618778628096/019f1510-1425-71d4-a18a-32a5945bb6f2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://facebook.com/Brilliant-Starts-Learning-Academy-183364385031891/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3782542306192013412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brilliant-starts-learning-academy",
      "poi_latitude": "29.7155609",
      "poi_longitude": "-98.0728104",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 830-708-2752",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b32-740f-bd4a-5cb17bfdd807",
        "storage_key": "property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5aQbGsa8XIYRZDh2zC9KfjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_d6209a638b25a99dfe0e80dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "TSTC in New Braunfels",
      "poi_type": "Education",
      "poi_address": "2189 FM 758, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-15ac-70ec-9d39-faaaed74462e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-15ac-70ec-9d39-faaaed74462e",
        "storage_key": "property/5767618778628096/019f1510-15ac-70ec-9d39-faaaed74462e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tstc.edu/campuses/txfame",
      "poi_directions_map_url": "https://maps.google.com/?cid=13896780735171179572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tstc-in-new-braunfels",
      "poi_latitude": "29.6953328",
      "poi_longitude": "-98.0400953",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 830-402-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b32-740f-bd4a-5cb17bfdd807",
        "storage_key": "property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfXMhTiy9XIYRNLReSXNI28A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_28727519f600b8d7c01e8970",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Northeast Lakeview College - New Braunfels",
      "poi_type": "Education",
      "poi_address": "2193 FM758, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-16de-765f-bd0c-fd46bf9e297e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-16de-765f-bd0c-fd46bf9e297e",
        "storage_key": "property/5767618778628096/019f1510-16de-765f-bd0c-fd46bf9e297e.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.alamo.edu/nlc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1075253174603126257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northeast-lakeview-college---new-braunfels",
      "poi_latitude": "29.6957046",
      "poi_longitude": "-98.0392885",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-486-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b32-740f-bd4a-5cb17bfdd807",
        "storage_key": "property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU4ujTQC7XIYR8ZXUuxAR7A4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_dcda56ab97c48531f30f3916",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Gruene Hall",
      "poi_type": "Entertainment",
      "poi_address": "1281 Gruene Rd, New Braunfels, TX 78130, USA",
      "poi_short_description": "Dance hall built in the 19th century hosting live country, Americana & blues musicians nightly.",
      "poi_long_description": "Dance hall built in the 19th century hosting live country, Americana & blues musicians nightly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-16c3-77b9-994e-f37dff5a2fb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-16c3-77b9-994e-f37dff5a2fb4",
        "storage_key": "property/5767618778628096/019f1510-16c3-77b9-994e-f37dff5a2fb4.webp",
        "width": 1280,
        "height": 904
      },
      "poi_business_url": "https://gruenehall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013316518106533398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gruene-hall",
      "poi_latitude": "29.7383595",
      "poi_longitude": "-98.104373",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 830-606-1281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_xNwmcWiXIYRFo5WwM_gkkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_abbdda62b38bd0131cc30e78",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Gristmill River Restaurant & Bar",
      "poi_type": "Entertainment",
      "poi_address": "1287 Gruene Rd, New Braunfels, TX 78130, USA",
      "poi_short_description": "Chicken-fried steak, burgers & ribs served in an 1878 cotton gin with a shady patio & river views.",
      "poi_long_description": "Chicken-fried steak, burgers & ribs served in an 1878 cotton gin with a shady patio & river views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150c-de29-7138-ab78-6d17c142cd34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-de29-7138-ab78-6d17c142cd34",
        "storage_key": "property/5767618778628096/019f150c-de29-7138-ab78-6d17c142cd34.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://gristmillrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10659667145605406025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gristmill-river-restaurant--bar",
      "poi_latitude": "29.738203",
      "poi_longitude": "-98.105163",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 830-625-0684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9bed139a0368",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9bed139a0368.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQy10k8WiXIYRSV22pcq-7pM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_ab742ad83a6ef79ef8d20f9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Brauntex Performing Arts Theatre",
      "poi_type": "Entertainment",
      "poi_address": "290 W San Antonio St, New Braunfels, TX 78130, USA",
      "poi_short_description": "Renovated circa-1942 movie theater hosting live music, ballet, musicals & other events.",
      "poi_long_description": "Renovated circa-1942 movie theater hosting live music, ballet, musicals & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-1ae2-71bb-bb1d-3b9600dd1a4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-1ae2-71bb-bb1d-3b9600dd1a4c",
        "storage_key": "property/5767618778628096/019f1510-1ae2-71bb-bb1d-3b9600dd1a4c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.brauntex.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1014441491659736198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brauntex-performing-arts-theatre",
      "poi_latitude": "29.70139129999999",
      "poi_longitude": "-98.1265756",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-627-0808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbUPiiV29XIYRhsTLcykFFA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_da8869fd4e214682488a89ca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Landa Park",
      "poi_type": "Entertainment",
      "poi_address": "164 Landa Park Dr, New Braunfels, TX 78130, USA",
      "poi_short_description": "51-acre riverside park with a miniature train, nature trail, mini-golf, picnic tables & more.",
      "poi_long_description": "51-acre riverside park with a miniature train, nature trail, mini-golf, picnic tables & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-04e0-70f9-8dea-e71e87283622.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-04e0-70f9-8dea-e71e87283622",
        "storage_key": "property/5767618778628096/019f150d-04e0-70f9-8dea-e71e87283622.webp",
        "width": 1280,
        "height": 801
      },
      "poi_business_url": "https://newbraunfels.gov/3375/Landa-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17119575220059397164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "landa-park",
      "poi_latitude": "29.7090026",
      "poi_longitude": "-98.13535",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 830-221-4350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b78-77fc-ad22-73ff2ba8aaac",
        "storage_key": "property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFa8iJFi9XIYRLFw4kfXylO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_dfa6705d697e20ab8e158202",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "McKenna Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "801 W San Antonio St, New Braunfels, TX 78130, USA",
      "poi_short_description": "Interactive exhibits for young kids focusing on space, culture & technology in colorful environs.",
      "poi_long_description": "Interactive exhibits for young kids focusing on space, culture & technology in colorful environs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150c-e46f-71ec-b00f-c550fec4ebc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-e46f-71ec-b00f-c550fec4ebc3",
        "storage_key": "property/5767618778628096/019f150c-e46f-71ec-b00f-c550fec4ebc3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.mckennakids.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6089669223898084398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckenna-childrens-museum",
      "poi_latitude": "29.6956491",
      "poi_longitude": "-98.1302413",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-606-9525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9685567b51ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9685567b51ff",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9685567b51ff.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6Bfe2G9XIYRLvQSCuXZglQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_6294d05e42364bfdb9de07ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "New Braunfels Railroad Museum",
      "poi_type": "Entertainment",
      "poi_address": "302 W San Antonio St, New Braunfels, TX 78130, USA",
      "poi_short_description": "Museum displaying a locomotive, train cars & model railroads in a converted rail depot.",
      "poi_long_description": "Museum displaying a locomotive, train cars & model railroads in a converted rail depot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-1cfd-7114-b0dd-1f329eb707ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-1cfd-7114-b0dd-1f329eb707ca",
        "storage_key": "property/5767618778628096/019f1510-1cfd-7114-b0dd-1f329eb707ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://newbraunfelsrailroadmuseum.org/nbrr/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4077173097532627790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-braunfels-railroad-museum",
      "poi_latitude": "29.7012832",
      "poi_longitude": "-98.1268231",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 830-627-2447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b4c-75a2-81d5-9685567b51ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b4c-75a2-81d5-9685567b51ff",
        "storage_key": "property/5767618778628096/019f150d-2b4c-75a2-81d5-9685567b51ff.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJndX4ZWe9XIYRThs2llQHlTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_5ff67231f6a7c407386b4dc7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Comal Tubes",
      "poi_type": "Entertainment",
      "poi_address": "1880 S Business IH 35, New Braunfels, TX 78130, USA",
      "poi_short_description": "Relaxed outfitter for tubing on the clear, spring-fed Comal River.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-1b96-703d-b3d3-a13480c5a611.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-1b96-703d-b3d3-a13480c5a611",
        "storage_key": "property/5767618778628096/019f1510-1b96-703d-b3d3-a13480c5a611.webp",
        "width": 1280,
        "height": 349
      },
      "poi_business_url": "https://comaltubes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6181307044935566605&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "comal-tubes",
      "poi_latitude": "29.685554",
      "poi_longitude": "-98.136896",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-609-9024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZaC55Wu9XIYRDQUB5QFqyFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_b499b446c30fb2e835c3920d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Texas Tubes",
      "poi_type": "Entertainment",
      "poi_address": "250 Meusebach St, New Braunfels, TX 78130, USA",
      "poi_short_description": "Water-sports company that rents tubes and shuttle services you to the Comal River for a leisurely float, plus man-made rapids.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-1b8f-7608-b124-e1963a3c70f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-1b8f-7608-b124-e1963a3c70f3",
        "storage_key": "property/5767618778628096/019f1510-1b8f-7608-b124-e1963a3c70f3.webp",
        "width": 826,
        "height": 562
      },
      "poi_business_url": "https://www.texastubes.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb-organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=3540090739173495163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-tubes",
      "poi_latitude": "29.7075863",
      "poi_longitude": "-98.1267088",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 830-626-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmUfbilu9XIYRexEWZcXtIDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_38c4d2ce1b978f7c8d47b29a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Corner Tubes",
      "poi_type": "Entertainment",
      "poi_address": "120 S Liberty St, New Braunfels, TX 78130, USA",
      "poi_short_description": "Veteran river outfitter offering a variety of tube rentals & bus shuttles to the Comal River.",
      "poi_long_description": "Veteran river outfitter offering a variety of tube rentals & bus shuttles to the Comal River.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-1cdb-75ea-9687-f487def439bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-1cdb-75ea-9687-f487def439bc",
        "storage_key": "property/5767618778628096/019f1510-1cdb-75ea-9687-f487def439bc.webp",
        "width": 1280,
        "height": 708
      },
      "poi_business_url": "http://www.cornertubes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8234715873271842607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corner-tubes",
      "poi_latitude": "29.7093746",
      "poi_longitude": "-98.1203391",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-626-6687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBe6tXveiXIYRL4ejFHWWR3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_b1c539d4161169a941971c42",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Santikos New Braunfels",
      "poi_type": "Entertainment",
      "poi_address": "651 S Business IH 35 Ste. 1010, New Braunfels, TX 78130, USA",
      "poi_short_description": "Modern cinema chain featuring leather recliner seats and gourmet snacks, plus bowling lanes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-1d8b-77c4-bdf0-3a84f4827b3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-1d8b-77c4-bdf0-3a84f4827b3d",
        "storage_key": "property/5767618778628096/019f1510-1d8b-77c4-bdf0-3a84f4827b3d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.santikos.com/new-braunfels/new-braunfels/theater-info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2722360502489686770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santikos-new-braunfels",
      "poi_latitude": "29.697457",
      "poi_longitude": "-98.1027053",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 877-691-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-46d9-7449-be57-914cc8e8f157.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-46d9-7449-be57-914cc8e8f157",
        "storage_key": "property/5767618778628096/019f1510-46d9-7449-be57-914cc8e8f157.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJFZuU12q9XIYR8qJzDXTExyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_7ea4cb1815936c7a8e39047d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "CHRISTUS Santa Rosa Hospital - New Braunfels",
      "poi_type": "Health and Wellness",
      "poi_address": "600 N Union Ave, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-0eaf-715a-9642-7c043d8792d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-0eaf-715a-9642-7c043d8792d8",
        "storage_key": "property/5767618778628096/019f150d-0eaf-715a-9642-7c043d8792d8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.christushealth.org/locations/santa-rosa-hospital-new-braunfels?utm_source=GBP&utm_medium=organic&utm_campaign=GBP-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15254853539854473751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christus-santa-rosa-hospital---new-braunfels",
      "poi_latitude": "29.7154219",
      "poi_longitude": "-98.1226435",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 830-606-9111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b30-70cd-ae03-1ecdc64a6ec6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b30-70cd-ae03-1ecdc64a6ec6",
        "storage_key": "property/5767618778628096/019f150d-2b30-70cd-ae03-1ecdc64a6ec6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJbeRaLVC9XIYRF9qih3ggtNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_e4063ef2d0e6a12c3a3fd38c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Methodist ER New Braunfels",
      "poi_type": "Health and Wellness",
      "poi_address": "1850 TX-46 #109, New Braunfels, TX 78132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-1f12-716b-b8ad-c3bac305c560.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-1f12-716b-b8ad-c3bac305c560",
        "storage_key": "property/5767618778628096/019f1510-1f12-716b-b8ad-c3bac305c560.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.sahealth.com/locations/methodist-er-new-braunfels?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=10604172295303694351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "methodist-er-new-braunfels",
      "poi_latitude": "29.7199832",
      "poi_longitude": "-98.1643718",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 210-757-5850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz7sxRYiXXIYRD4id7oSWKZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_30dcae9c64cdeb97f4912a29",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Guadalupe Regional Urgent Care at Clear Springs",
      "poi_type": "Health and Wellness",
      "poi_address": "1761 TX-46 Ste 104, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-1f0d-71fa-9de7-f9f47753a871.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-1f0d-71fa-9de7-f9f47753a871",
        "storage_key": "property/5767618778628096/019f1510-1f0d-71fa-9de7-f9f47753a871.webp",
        "width": 1280,
        "height": 455
      },
      "poi_business_url": "https://grmcurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16130124312689887884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "guadalupe-regional-urgent-care-at-clear-springs",
      "poi_latitude": "29.675282",
      "poi_longitude": "-98.0580958",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 830-433-7816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2zfpIZ-9XIYRjMrF8Jm22d8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_b1a4e3aa5a6f24e162b4459f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "CHRISTUS Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1659 TX-46 #160, New Braunfels, TX 78132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-1f0c-711f-a8ef-df5cd64bafd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-1f0c-711f-a8ef-df5cd64bafd8",
        "storage_key": "property/5767618778628096/019f1510-1f0c-711f-a8ef-df5cd64bafd8.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.christushealth.org/locations/urgent-care-new-braunfels?utm_source=GBP&utm_medium=organic&utm_campaign=GBP-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12760428015092956585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christus-urgent-care",
      "poi_latitude": "29.7140321",
      "poi_longitude": "-98.1612659",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 830-387-4991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97_60sSXXIYRqf2ODawlFrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_b1b0a6eb628bcd51deb17cba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1655 TX-46, New Braunfels, TX 78132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-2073-74a3-9348-c2ccf066205e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-2073-74a3-9348-c2ccf066205e",
        "storage_key": "property/5767618778628096/019f1510-2073-74a3-9348-c2ccf066205e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.heb.com/pharmacy/common/landing?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=17375654224371689015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "29.7130374",
      "poi_longitude": "-98.1604729",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 830-626-3348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-46c6-7439-afcb-57f54b68cbc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-46c6-7439-afcb-57f54b68cbc7",
        "storage_key": "property/5767618778628096/019f1510-46c6-7439-afcb-57f54b68cbc7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5a81XoyXXIYRN6aw93S5IvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_65476f373df82f5a67a068c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1910 State Hwy 46 W, New Braunfels, TX 78132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-0a41-720d-a901-f3ca1bb6488b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-0a41-720d-a901-f3ca1bb6488b",
        "storage_key": "property/5767618778628096/019f1510-0a41-720d-a901-f3ca1bb6488b.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/new-braunfels-tx-pharmacies/1910-state-highway-46-w-new-braunfels-tx-78132/storeid=10947?WT.mc_id=LS_GOOGLE_RX_10947",
      "poi_directions_map_url": "https://maps.google.com/?cid=17252362955929889824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.7204549",
      "poi_longitude": "-98.1666113",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 830-620-9926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-46c6-7439-afcb-57f54b68cbc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-46c6-7439-afcb-57f54b68cbc7",
        "storage_key": "property/5767618778628096/019f1510-46c6-7439-afcb-57f54b68cbc7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqquqZXIYRICxPlLO0bO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_8c0bb8f15d7e68d8c2a74fd8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1610 State Hwy 46 W, New Braunfels, TX 78132, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-0aa7-76f5-a608-e1d1146be6d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-0aa7-76f5-a608-e1d1146be6d1",
        "storage_key": "property/5767618778628096/019f1510-0aa7-76f5-a608-e1d1146be6d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1610+state+highway+46+w-new+braunfels-tx-78132/id=10393",
      "poi_directions_map_url": "https://maps.google.com/?cid=2960251706703613184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.7155422",
      "poi_longitude": "-98.1577671",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 830-626-7142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjz9q8IyXXIYRAA3QPz7tFCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_3bbd6edc263464de50628fba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1671 S I-35 South Frontage Rd Ste 401, New Braunfels, TX 78130, USA",
      "poi_short_description": "Gym chain with a variety of fitness equipment and tanning options, plus a judgment-free atmosphere.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150c-f14f-770f-8a70-28e27e294f96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150c-f14f-770f-8a70-28e27e294f96",
        "storage_key": "property/5767618778628096/019f150c-f14f-770f-8a70-28e27e294f96.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/new-braunfels-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13213390237081548791&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "29.6823443",
      "poi_longitude": "-98.1349123",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-609-9241",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTctQ0n29XIYR9zfcv2lkX7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_74a2c17c64c6ceb4c9a6a641",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1691 TX-46, New Braunfels, TX 78132, USA",
      "poi_short_description": "Heart-rate-based group workout spot combining cardio and strength training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-246e-74fd-a28d-9d93c65c5100.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-246e-74fd-a28d-9d93c65c5100",
        "storage_key": "property/5767618778628096/019f1510-246e-74fd-a28d-9d93c65c5100.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/new-braunfels-texas-0516?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=7494617141916836393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "29.7157092",
      "poi_longitude": "-98.1615789",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 830-312-4660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdfUGBoyXXIYRKaKBF5U6Amg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_ce4cc190740f7e0bd0348a5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "HOTWORX - New Braunfels, TX",
      "poi_type": "Health and Wellness",
      "poi_address": "2188 TX-46 Ste 108, New Braunfels, TX 78132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-20ba-755f-9515-88a50274e7bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-20ba-755f-9515-88a50274e7bc",
        "storage_key": "property/5767618778628096/019f1510-20ba-755f-9515-88a50274e7bc.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/newbraunfels?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=10883896761644081556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---new-braunfels-tx",
      "poi_latitude": "29.7219547",
      "poi_longitude": "-98.1738809",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 830-310-4424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b32-740f-bd4a-5cb17bfdd807",
        "storage_key": "property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_6tUYfuZXIYRlOHReXBeC5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_2b688e36bfe576f9e5dadb0b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Landa Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "164 Landa Park Dr, New Braunfels, TX 78130, USA",
      "poi_short_description": "51-acre riverside park with a miniature train, nature trail, mini-golf, picnic tables & more.",
      "poi_long_description": "51-acre riverside park with a miniature train, nature trail, mini-golf, picnic tables & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-04e0-70f9-8dea-e71e87283622.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-04e0-70f9-8dea-e71e87283622",
        "storage_key": "property/5767618778628096/019f150d-04e0-70f9-8dea-e71e87283622.webp",
        "width": 1280,
        "height": 801
      },
      "poi_business_url": "https://newbraunfels.gov/3375/Landa-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17119575220059397164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "landa-park",
      "poi_latitude": "29.7090026",
      "poi_longitude": "-98.13535",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 830-221-4350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b78-77fc-ad22-73ff2ba8aaac",
        "storage_key": "property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFa8iJFi9XIYRLFw4kfXylO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c5854093a8fab5ec02c32b11",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Prince Solms Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Liebscher Dr, New Braunfels, TX 78130, USA",
      "poi_short_description": "Family-friendly park, river float and picnic spot featuring tube chutes, disc golf and basketball.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-1803-710d-b154-98fa4fe31fd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-1803-710d-b154-98fa4fe31fd2",
        "storage_key": "property/5767618778628096/019f150d-1803-710d-b154-98fa4fe31fd2.webp",
        "width": 963,
        "height": 1280
      },
      "poi_business_url": "https://www.newbraunfels.gov/Facilities/Facility/Details/Prince-Solms-Park-30",
      "poi_directions_map_url": "https://maps.google.com/?cid=15575180536584063250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prince-solms-park",
      "poi_latitude": "29.7081878",
      "poi_longitude": "-98.1214821",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 830-221-4350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b78-77fc-ad22-73ff2ba8aaac",
        "storage_key": "property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb9UhmES9XIYREsmrWy0oJtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_fcbe17f331cb22f99eda38ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Hinman Island Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Hinman Island Dr, New Braunfels, TX 78130, USA",
      "poi_short_description": "This 10-acre recreation area has paved paths, kids' play sets & picnic tables, plus water access.",
      "poi_long_description": "This 10-acre recreation area has paved paths, kids' play sets & picnic tables, plus water access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-174e-767a-9eb9-377d73b18274.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-174e-767a-9eb9-377d73b18274",
        "storage_key": "property/5767618778628096/019f150d-174e-767a-9eb9-377d73b18274.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.newbraunfels.gov/Facilities/Facility/Details/Hinman-Island-Park-18",
      "poi_directions_map_url": "https://maps.google.com/?cid=9126555007976339006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hinman-island-park",
      "poi_latitude": "29.7084",
      "poi_longitude": "-98.1242",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 830-221-4350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b78-77fc-ad22-73ff2ba8aaac",
        "storage_key": "property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8b0bcVu9XIYRPvZ92WwJqH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a135af47311d8c5a51371b28",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Cypress Bend Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "503 Peace Ave, New Braunfels, TX 78130, USA",
      "poi_short_description": "Forested area on a river with fishing, swimming, picnic & play areas, plus BBQ & horseshoe pits.",
      "poi_long_description": "Forested area on a river with fishing, swimming, picnic & play areas, plus BBQ & horseshoe pits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-1ac6-7728-8fa3-b944dc2e524f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-1ac6-7728-8fa3-b944dc2e524f",
        "storage_key": "property/5767618778628096/019f150d-1ac6-7728-8fa3-b944dc2e524f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://newbraunfels.gov/Facilities/Facility/Details/Cypress-Bend-Park-10",
      "poi_directions_map_url": "https://maps.google.com/?cid=14218851040982237701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cypress-bend-park",
      "poi_latitude": "29.7122214",
      "poi_longitude": "-98.1065113",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-221-4350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b78-77fc-ad22-73ff2ba8aaac",
        "storage_key": "property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc_R5gTm9XIYRBYLw46-BU8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3ea7377ec99813a4997218b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "River Acres Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "501 Fair Ln, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-2bec-719d-a32c-c78148a5fdf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-2bec-719d-a32c-c78148a5fdf8",
        "storage_key": "property/5767618778628096/019f1510-2bec-719d-a32c-c78148a5fdf8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8755115225177739851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-acres-park",
      "poi_latitude": "29.715346",
      "poi_longitude": "-98.1090256",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b78-77fc-ad22-73ff2ba8aaac",
        "storage_key": "property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__-_dDe9XIYRS1JVJOlqgHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_468bc68ac047c34d4a5a2d0f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Puppy Playland Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1240 Landa St, New Braunfels, TX 78132, USA",
      "poi_short_description": "Fenced public park featuring agility equipment, play trails, and water fountains, as well as a dog wash area and separate sections for large and small dogs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-2485-7043-bfc0-ce90d4db902b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-2485-7043-bfc0-ce90d4db902b",
        "storage_key": "property/5767618778628096/019f1510-2485-7043-bfc0-ce90d4db902b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://newbraunfels.gov/facilities/facility/details/Puppy-Playland-Dog-Park-31",
      "poi_directions_map_url": "https://maps.google.com/?cid=11881200201031727524&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "puppy-playland-dog-park",
      "poi_latitude": "29.6965434",
      "poi_longitude": "-98.1555683",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 830-221-4350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b78-77fc-ad22-73ff2ba8aaac",
        "storage_key": "property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJhWcHg8CXXIYRpLnLL6KA4qQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_cf1927dc5cf32f6045da9d3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Fischer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1935 Hilltop Smt Rd, New Braunfels, TX 78130, USA",
      "poi_short_description": "Large green space with 2 mi. of trails, 2 fishing ponds, a splash pad & a playground.",
      "poi_long_description": "Large green space with 2 mi. of trails, 2 fishing ponds, a splash pad & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-0b16-70ef-82ec-d7f5af396ee2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-0b16-70ef-82ec-d7f5af396ee2",
        "storage_key": "property/5767618778628096/019f150d-0b16-70ef-82ec-d7f5af396ee2.webp",
        "width": 1280,
        "height": 765
      },
      "poi_business_url": "https://www.newbraunfels.gov/3379/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6344102959806883006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fischer-park",
      "poi_latitude": "29.6774926",
      "poi_longitude": "-98.1109404",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 830-221-4378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b78-77fc-ad22-73ff2ba8aaac",
        "storage_key": "property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2XFHw6C9XIYRviTLiQfIClg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_ba58d31d36d11e73bf4acf04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Dry Comal Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 Landa St, New Braunfels, TX 78132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-2bed-7791-a00b-5854f0576a28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-2bed-7791-a00b-5854f0576a28",
        "storage_key": "property/5767618778628096/019f1510-2bed-7791-a00b-5854f0576a28.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10408406112960643420&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dry-comal-trail",
      "poi_latitude": "29.6927942",
      "poi_longitude": "-98.1540271",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b78-77fc-ad22-73ff2ba8aaac",
        "storage_key": "property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPaP4vMCXXIYRXAEGsTYWcpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_41709a861ddb0b7ee7e9f34a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Potters Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3145 Potters Creek Rd, Canyon Lake, TX 78133, USA",
      "poi_short_description": "Scenic landscape with trails, wildlife, campgrounds & a lake for boating, swimming & fishing.",
      "poi_long_description": "Scenic landscape with trails, wildlife, campgrounds & a lake for boating, swimming & fishing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-240c-7734-a223-217e5ffa0286.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-240c-7734-a223-217e5ffa0286",
        "storage_key": "property/5767618778628096/019f1510-240c-7734-a223-217e5ffa0286.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.recreation.gov/camping/Potters_Creek_Park_Tx/r/campgroundDetails.do?contractCode=NRSO&parkId=75020",
      "poi_directions_map_url": "https://maps.google.com/?cid=17448830307302657428&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "potters-creek-park",
      "poi_latitude": "29.9067266",
      "poi_longitude": "-98.2638628",
      "poi_miles_from_property": "35.7 mi",
      "poi_walking_minutes": "13 hours 14 mins",
      "poi_biking_minutes": "2 hours 33 mins",
      "poi_driving_minutes": "44 mins",
      "poi_business_phone": "+1 830-964-3341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b78-77fc-ad22-73ff2ba8aaac",
        "storage_key": "property/5767618778628096/019f150d-2b78-77fc-ad22-73ff2ba8aaac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7c1294diW4YRlE3YdLeyJvI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6c4eb4ca00e155f4617af944",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Canyon Lake Gorge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16029 S Access Rd, Canyon Lake, TX 78133, USA",
      "poi_short_description": "Scenic & educational destination for self-guided tours offering views of a 2002 flood-carved gorge and fossils of dinosaur tracks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-2476-762a-a1cf-b4ba61d9a229.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-2476-762a-a1cf-b4ba61d9a229",
        "storage_key": "property/5767618778628096/019f1510-2476-762a-a1cf-b4ba61d9a229.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gbra.org/recreation/canyon-lake-gorge/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16298356688089572577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canyon-lake-gorge",
      "poi_latitude": "29.865341",
      "poi_longitude": "-98.1891063",
      "poi_miles_from_property": "27.6 mi",
      "poi_walking_minutes": "10 hours 11 mins",
      "poi_biking_minutes": "1 hour 46 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 830-964-5424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe3egMOSfXIYR4eQwMA5lL-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_454ae0f045c4c16750512dea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Park And Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "222-232 TX-337 Loop, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5254382712460221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park-and-ride",
      "poi_latitude": "29.7043665",
      "poi_longitude": "-98.0972942",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-46c6-7439-afcb-5aa1c6b50881.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-46c6-7439-afcb-5aa1c6b50881",
        "storage_key": "property/5767618778628096/019f1510-46c6-7439-afcb-5aa1c6b50881.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95NbbSK9XIYRvRMXT9WqEgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_65ca3f8bbac7d0e9ef8cb1fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "TA Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4817 I-35, New Braunfels, TX 78130, USA",
      "poi_short_description": "Travel stop offering truck parking, fuel, repairs, and shopping, plus a driver's lounge.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-28d5-7757-8402-03e0cf655940.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-28d5-7757-8402-03e0cf655940",
        "storage_key": "property/5767618778628096/019f1510-28d5-7757-8402-03e0cf655940.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ta-petro.com/location/tx/ta-new-braunfels/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17779070485908342678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ta-travel-center",
      "poi_latitude": "29.7489043",
      "poi_longitude": "-98.057887",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 830-608-9395",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBVgP1kKjXIYRlscyzWjyu_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "rest_stop"
    },
    {
      "id": "ec_25f531c3310bbeca646c94de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "338 S Guadalupe St, San Marcos, TX 78666, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-2bec-719d-a32c-c141d7cb1205.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-2bec-719d-a32c-c141d7cb1205",
        "storage_key": "property/5767618778628096/019f1510-2bec-719d-a32c-c141d7cb1205.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/san-marcos-tx/san-marcos-carts?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=3635697392427832619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "29.8765025",
      "poi_longitude": "-97.9411686",
      "poi_miles_from_property": "19.0 mi",
      "poi_walking_minutes": "6 hours 55 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfxtBp2GoXIYRK5V5AoSXdDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_3eec7ad7864cdaa4365f3160",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "New Braunfels National Airport & FBO",
      "poi_type": "Transportation & Transit",
      "poi_address": "2333 FM 758, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-1165-7219-bdb7-1fb63f3a51ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-1165-7219-bdb7-1fb63f3a51ee",
        "storage_key": "property/5767618778628096/019f150d-1165-7219-bdb7-1fb63f3a51ee.webp",
        "width": 1280,
        "height": 641
      },
      "poi_business_url": "https://newbraunfels.gov/3488/Airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=7711774081790518615&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-braunfels-national-airport--fbo",
      "poi_latitude": "29.6988659",
      "poi_longitude": "-98.0385858",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 830-221-4290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b34-740c-b05d-f42214835b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b34-740c-b05d-f42214835b41",
        "storage_key": "property/5767618778628096/019f150d-2b34-740c-b05d-f42214835b41.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJA44iw2C7XIYRVyUwLau5BWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_97201e0b79c6d887901bd24a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "San Antonio International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9800 Airport Blvd, San Antonio, TX 78216, USA",
      "poi_short_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_long_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-2b18-71fb-9881-7c5ce22b1dc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-2b18-71fb-9881-7c5ce22b1dc2",
        "storage_key": "property/5767618778628096/019f1510-2b18-71fb-9881-7c5ce22b1dc2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.flysanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18041828760938859602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-international-airport",
      "poi_latitude": "29.5331282",
      "poi_longitude": "-98.4705422",
      "poi_miles_from_property": "30.8 mi",
      "poi_walking_minutes": "11 hours 23 mins",
      "poi_biking_minutes": "3 hours 8 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 210-207-3433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b34-740c-b05d-f42214835b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b34-740c-b05d-f42214835b41",
        "storage_key": "property/5767618778628096/019f150d-2b34-740c-b05d-f42214835b41.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4DLsbuKXIYRUswvGqtzYfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_ce7e22de377092d3f01331f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Buc-ee's",
      "poi_type": "Transportation & Transit",
      "poi_address": "2760 I-35, New Braunfels, TX 78130, USA",
      "poi_short_description": "Chain of convenience stores for snacks & drinks, plus eclectic themed T-shirts & knickknacks.",
      "poi_long_description": "Chain of convenience stores for snacks & drinks, plus eclectic themed T-shirts & knickknacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-2f1c-77cd-936c-8c6e70e1b254.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-2f1c-77cd-936c-8c6e70e1b254",
        "storage_key": "property/5767618778628096/019f1510-2f1c-77cd-936c-8c6e70e1b254.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.buc-ees.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7590642102893115012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buc-ees",
      "poi_latitude": "29.726334",
      "poi_longitude": "-98.0783334",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 979-238-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-46c4-7691-8318-f40c972f9361.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-46c4-7691-8318-f40c972f9361",
        "storage_key": "property/5767618778628096/019f1510-46c4-7691-8318-f40c972f9361.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJs-S_RM28XIYRhHYRkMZgV2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_f9376934ce69f363cfcffccc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Pilot Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4142 TX-337 Loop, New Braunfels, TX 78130, USA",
      "poi_short_description": "Clean, modern gas station, convenience store stocking snacks and drinks, plus a restaurant.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-321e-7777-afd0-08c4b83c7a7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-321e-7777-afd0-08c4b83c7a7a",
        "storage_key": "property/5767618778628096/019f1510-321e-7777-afd0-08c4b83c7a7a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.pilotflyingj.com/us/tx/new-braunfels/4142-tx-337-loop",
      "poi_directions_map_url": "https://maps.google.com/?cid=9066875282178535248&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pilot-travel-center",
      "poi_latitude": "29.6763531",
      "poi_longitude": "-98.1560214",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 830-629-1424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b80-742a-ac3b-ca54954116e4",
        "storage_key": "property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa3p0UTWWXIYRUG8F4QcD1H0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_stop"
    },
    {
      "id": "ec_025e7cd53ad685f8646909f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "TA Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4817 I-35, New Braunfels, TX 78130, USA",
      "poi_short_description": "Travel stop offering truck parking, fuel, repairs, and shopping, plus a driver's lounge.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-303a-779c-b606-6e3b542cb750.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-303a-779c-b606-6e3b542cb750",
        "storage_key": "property/5767618778628096/019f1510-303a-779c-b606-6e3b542cb750.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ta-petro.com/location/tx/ta-new-braunfels/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17779070485908342678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ta-travel-center",
      "poi_latitude": "29.7489043",
      "poi_longitude": "-98.057887",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 830-608-9395",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBVgP1kKjXIYRlscyzWjyu_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "rest_stop"
    },
    {
      "id": "ec_c88b268ca045605ec445603a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Tex Best Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "2735 I 35 N Frontage Rd, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-3235-731c-bd82-3d9e82d5195b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-3235-731c-bd82-3d9e82d5195b",
        "storage_key": "property/5767618778628096/019f1510-3235-731c-bd82-3d9e82d5195b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8739168689534760883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tex-best-travel-center",
      "poi_latitude": "29.7292535",
      "poi_longitude": "-98.0794335",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-629-2054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-46c4-7691-8318-f40c972f9361.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-46c4-7691-8318-f40c972f9361",
        "storage_key": "property/5767618778628096/019f1510-46c4-7691-8318-f40c972f9361.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJuVnqYi2jXIYRs3fv-57DR3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_b29c7d428a2cf667ed05050b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "New Braunfels Town Center at Creekside",
      "poi_type": "Transportation & Transit",
      "poi_address": "161 Creekside Way, New Braunfels, TX 78130, USA",
      "poi_short_description": "Big-box stores, retail shops, a movie theater & restaurants draw locals to this shopping center.",
      "poi_long_description": "Big-box stores, retail shops, a movie theater & restaurants draw locals to this shopping center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-32e4-7176-ab48-0dcd888370e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-32e4-7176-ab48-0dcd888370e6",
        "storage_key": "property/5767618778628096/019f1510-32e4-7176-ab48-0dcd888370e6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.newbraunfelstowncenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2426665019078327336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-braunfels-town-center-at-creekside",
      "poi_latitude": "29.7289545",
      "poi_longitude": "-98.0739354",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-477-4378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b80-742a-ac3b-ca54954116e4",
        "storage_key": "property/5767618778628096/019f150d-2b80-742a-ac3b-ca54954116e4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_UQQuTSjXIYRKLwHU_o-rSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_369d5df1e94067e4ba226a6a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "CHRISTUS Santa Rosa Hospital - New Braunfels",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 N Union Ave, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-0eaf-715a-9642-7c043d8792d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-0eaf-715a-9642-7c043d8792d8",
        "storage_key": "property/5767618778628096/019f150d-0eaf-715a-9642-7c043d8792d8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.christushealth.org/locations/santa-rosa-hospital-new-braunfels?utm_source=GBP&utm_medium=organic&utm_campaign=GBP-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15254853539854473751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christus-santa-rosa-hospital---new-braunfels",
      "poi_latitude": "29.7154219",
      "poi_longitude": "-98.1226435",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 830-606-9111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b30-70cd-ae03-1ecdc64a6ec6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b30-70cd-ae03-1ecdc64a6ec6",
        "storage_key": "property/5767618778628096/019f150d-2b30-70cd-ae03-1ecdc64a6ec6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJbeRaLVC9XIYRF9qih3ggtNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_1ecb71380ecc8ec7bb0793f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Walmart/Sam's Club Distribution Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3900 I 35 N Frontage Rd, New Braunfels, TX 78130, USA",
      "poi_short_description": "Distribution service for the Walmart chain featuring loading docks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-3555-740e-a34b-ebf8d8a7e49d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-3555-740e-a34b-ebf8d8a7e49d",
        "storage_key": "property/5767618778628096/019f1510-3555-740e-a34b-ebf8d8a7e49d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.walmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16712411030069207308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmartsams-club-distribution-center",
      "poi_latitude": "29.737035",
      "poi_longitude": "-98.063936",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 830-620-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8zPuhESjXIYRDGGYI0lp7uc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supplier"
    },
    {
      "id": "ec_3a046107588e5d2504ba7e3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Sysco Central Texas - Food Distributor & Restaurant Supplies",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1260 Schwab Rd, New Braunfels, TX 78132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-33bb-754d-bcc0-794026a30f0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-33bb-754d-bcc0-794026a30f0f",
        "storage_key": "property/5767618778628096/019f1510-33bb-754d-bcc0-794026a30f0f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://cloud.email.sysco.com/become-a-customer?utm_medium=googlemybusiness&utm_source=google.com&utm_campaign=gmb_opcopages&utm_content=central_texas",
      "poi_directions_map_url": "https://maps.google.com/?cid=2054358179178538336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sysco-central-texas---food-distributor--restaurant-supplies",
      "poi_latitude": "29.6432987",
      "poi_longitude": "-98.215565",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 26 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 830-730-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ64bYla-WXIYRYOVaJ-GLghw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wholesaler"
    },
    {
      "id": "ec_57950e5f11d8424f659ce1b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Task Us Galaxis",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1650 Independence Dr, New Braunfels, TX 78132, USA",
      "poi_short_description": "Business-to-business service with many reviews about employment matters.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-36d6-701c-8d46-ff0a98d6206d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-36d6-701c-8d46-ff0a98d6206d",
        "storage_key": "property/5767618778628096/019f1510-36d6-701c-8d46-ff0a98d6206d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.taskus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18257850315468750731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "task-us-galaxis",
      "poi_latitude": "29.7180753",
      "poi_longitude": "-98.1569157",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 888-400-8275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvZQRkGqXXIYRi7_EryDqYP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_c4601f6f6f9b8759beedf77a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Rush Enterprises, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "555 S I-35 South Frontage Rd #500, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-141b-76cd-820c-47a04661aac1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-141b-76cd-820c-47a04661aac1",
        "storage_key": "property/5767618778628096/019f150d-141b-76cd-820c-47a04661aac1.webp",
        "width": 1280,
        "height": 726
      },
      "poi_business_url": "https://www.rushenterprises.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb-enterprises",
      "poi_directions_map_url": "https://maps.google.com/?cid=7527619510384321381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rush-enterprises-inc",
      "poi_latitude": "29.6879246",
      "poi_longitude": "-98.1174155",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 830-302-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbZJKnK9XIYRZePByA96d2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_d68c8767e8926a48cdedf125",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "IBEX Global New Braunfels",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1672 Independence Dr #200, New Braunfels, TX 78132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-36d3-72e3-bd25-103702741090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-36d3-72e3-bd25-103702741090",
        "storage_key": "property/5767618778628096/019f1510-36d3-72e3-bd25-103702741090.webp",
        "width": 828,
        "height": 732
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17602674154567219129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ibex-global-new-braunfels",
      "poi_latitude": "29.7190812",
      "poi_longitude": "-98.15934310000002",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 830-218-4219",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJffbZEjyXXIYRubftb-FCSfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_80f2d4e837f9889aeb2a6b0e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "Comal Independent School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1404 I 35 N Frontage Rd, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-3801-727c-afb1-bbf785b4d2fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-3801-727c-afb1-bbf785b4d2fb",
        "storage_key": "property/5767618778628096/019f1510-3801-727c-afb1-bbf785b4d2fb.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.comalisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5696608844939480264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "comal-independent-school-district",
      "poi_latitude": "29.70503149999999",
      "poi_longitude": "-98.0890955",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 830-221-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b32-740f-bd4a-5cb17bfdd807",
        "storage_key": "property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw3nPjmOkXIYRyEz3ApBrDk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_235e0ad05086d82f8e0cfb6e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "New Braunfels Independent School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 N Walnut Ave, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://nbisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11668947348563653969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-braunfels-independent-school-district",
      "poi_latitude": "29.7062489",
      "poi_longitude": "-98.1414272",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 830-643-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b32-740f-bd4a-5cb17bfdd807",
        "storage_key": "property/5767618778628096/019f150d-2b32-740f-bd4a-5cb17bfdd807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-3ORtiKXXIYRUXXf7clt8KE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_44be30622bafc58f4cb8fe8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "New Braunfels Utilities",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Customer Solutions Center, 1488 S Seguin Ave, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-3cd5-770a-9c00-0472060b5b86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-3cd5-770a-9c00-0472060b5b86",
        "storage_key": "property/5767618778628096/019f1510-3cd5-770a-9c00-0472060b5b86.webp",
        "width": 1280,
        "height": 1052
      },
      "poi_business_url": "https://www.nbutexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12192957965406432748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-braunfels-utilities",
      "poi_latitude": "29.6878181",
      "poi_longitude": "-98.1093669",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-629-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b47-70bf-af45-85c33d3bcce7",
        "storage_key": "property/5767618778628096/019f150d-2b47-70bf-af45-85c33d3bcce7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT5U9P129XIYR7O1RIasWNqk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_084a20d94d3f576df7ae64cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "poi_name": "New Braunfels Regional Rehabilitation Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2041 Sundance Parkway, New Braunfels, TX 78130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1510-3942-736b-ac99-7c686446f6d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-3942-736b-ac99-7c686446f6d6",
        "storage_key": "property/5767618778628096/019f1510-3942-736b-ac99-7c686446f6d6.webp",
        "width": 1000,
        "height": 657
      },
      "poi_business_url": "http://nbrrh.ernesthealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15729420103025717647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-braunfels-regional-rehabilitation-hospital",
      "poi_latitude": "29.7349992",
      "poi_longitude": "-98.0951208",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 830-625-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f150d-2b30-70cd-ae03-1ecdc64a6ec6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150d-2b30-70cd-ae03-1ecdc64a6ec6",
        "storage_key": "property/5767618778628096/019f150d-2b30-70cd-ae03-1ecdc64a6ec6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJgT8K3NaiXIYRj3G84z4gSto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "custom_a3c5a759-cdee-447c-8ddc-ae8766ff87bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_741b99e5-ee6c-4124-a3a4-2a340e7eaedd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c1377004-7e1e-4e2c-8e45-b23fde06a2d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_37d00f97-2e41-47f0-8775-03f53b9b331c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_5db3acaf-4fbf-4e3a-8d9c-b7393fa397f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_62875a50-7d1d-4134-a467-6e3898198e12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_efa7449d-1808-4020-a7b7-c3a5aa89432c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [
    {
      "id": "ec_5613aa84396056d80cd25939",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f14c4-7c4d-7636-8598-10b0c13676f0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-7c4d-7636-8598-10b0c13676f0",
        "storage_key": "property/5767618778628096/019f14c4-7c4d-7636-8598-10b0c13676f0.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Clear Springs | Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/1rXDVx1XSDI?rel=0"
    }
  ],
  "faqs": [
    {
      "id": "custom_9ee9a118-5b3c-4e7c-9883-dfb603322f86",
      "question": "Is Clear Springs pet-friendly?",
      "answer": "Yes. Clear Springs welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (830) 837-5885 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_1591ac76-819c-4319-a63a-b5d427733a17",
      "question": "How can I schedule a tour at Clear Springs?",
      "answer": "You can schedule a tour of Clear Springs online through our Schedule a Tour page, or call the leasing office at (830) 837-5885. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_eaeefafe-85de-4046-a0ef-ff7ec4a59e1a",
      "question": "What are the leasing office hours at Clear Springs?",
      "answer": "The Clear Springs leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (830) 837-5885 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_ec5e2eab-9e81-4e1e-bcc3-e2503dd6415d",
      "question": "What floor plans are available at Clear Springs?",
      "answer": "Clear Springs offers 1- and 2-bedroom apartment homes ranging from approximately 499 to 937 square feet, across 4 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_20f6a94a-0522-430c-a26f-72dc98bbcc06",
      "question": "What amenities does Clear Springs have?",
      "answer": "Clear Springs offers a range of community and in-home amenities. Community amenities include: LUXER Package Locker, American Landmark 360, Car Charging Stations, Dog Park, Fitness Center, Grill Area, Online Resident Services, Outside Space, Pool, Select Homes, Cyber Cafe, and Valet Trash Service. In-home features include: counters, hard floors, kitchen appliances, sink, tall ceilings, tile backsplash, w&d included, and walk-in closet. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_df1c7ea2-487b-4aec-a642-533414631b31",
      "question": "Where is Clear Springs located?",
      "answer": "Clear Springs is located at 1767 TX-46, New Braunfels TX 78130. Nearby you'll find dining at Clear Springs Restaurant, shopping at H-E-B, and green space at Landa Park. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_095d5996-4b59-40de-a2f0-1bda54876d62",
      "question": "How do I apply to live at Clear Springs?",
      "answer": "You can apply to live at Clear Springs online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (830) 837-5885 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_cd706954-01e7-4e49-b14c-4a0c50b33385",
      "question": "What do I need to apply at Clear Springs?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Clear Springs leasing team at (830) 837-5885 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_ee715392-9f92-486b-bfc8-1fe52a724442",
      "question": "What is the Landmark 360 program at Clear Springs?",
      "answer": "Clear Springs participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (830) 837-5885 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_b389196c-fc20-438f-96e4-49d84d955fee",
      "question": "Does Clear Springs have a pool?",
      "answer": "Yes. Clear Springs has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_70dc5d0e-a947-4d82-ac88-0d07c6be7bbb",
      "question": "Does Clear Springs have a fitness center?",
      "answer": "Yes. Clear Springs has a fitness center for residents. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_f3c02509-f75b-4f10-a579-539638633b15",
      "question": "Does Clear Springs have a dog park?",
      "answer": "Yes. Clear Springs has an on-site dog park for residents and their dogs. See more community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_27161a09-e63e-4cdb-a0ae-cdc0242eb5c8",
      "question": "Does Clear Springs offer virtual tours?",
      "answer": "Yes. Clear Springs offers virtual tours of Clear Springs | Community Tour. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_6f518d84-64a3-44a0-88ef-3b6646d34868",
      "question": "When was Clear Springs built?",
      "answer": "Clear Springs was built in 2021. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_b191ac0e-2019-4465-862f-75fb8f12ebd7",
      "question": "What is the pet fee at Clear Springs?",
      "answer": "Pets at Clear Springs: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (830) 837-5885 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_5b9ab030-7b3e-41ac-a729-d5ebd4a3c9f8",
      "question": "What features are included in the apartments at Clear Springs?",
      "answer": "Apartment homes at Clear Springs include counters, hard floors, kitchen appliances, sink, tall ceilings, tile backsplash, w&d included, and walk-in closet. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_5e600772-d29b-4cc5-b337-a326112aa612",
      "question": "What restaurants and shops are near Clear Springs?",
      "answer": "Nearby restaurants and shops include Clear Springs Restaurant, The Reel Seafood & Grill, McAlister's Deli, and Whataburger. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-5500-75e0-baa8-ed2a36014469",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "clear-springs",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096"
    },
    {
      "lead_collector_id": "0198aa45-5561-74fe-aad9-60700914f09d",
      "lead_source": "FACEBOOK_ADS",
      "name": "clear-springs",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096"
    },
    {
      "lead_collector_id": "0198aa45-55c3-76eb-b9a9-097ad1982390",
      "lead_source": "LANDING_PAGE",
      "name": "clear-springs",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-new-braunfels-tx",
      "search_query": "One Bedroom Apartments For Rent In New Braunfels TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In New Braunfels TX",
      "h2_subtitle": "Discover the perfect blend of comfort and convenience at Clear Springs. Our one bedroom apartments feature modern amenities to enhance your living experience.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. Our one bedroom apartments for rent in New Braunfels TX feature thoughtfully designed interiors that will make you look forward to coming home every day. Enjoy modern amenities such as washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is equipped with a dishwasher, disposal, oven, refrigerator, and freezer, making meal prep a breeze. Relax in your tub/shower or unwind on your private patio. At Clear Springs, we aim to provide a living experience that combines comfort and convenience in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | One Bedroom Apartments For Rent In New Braunfels TX",
      "seo_description": "Find one bedroom apartments for rent in New Braunfels TX at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-new-braunfels-tx",
      "search_query": "Two Bedrooms Apartments For Rent In New Braunfels TX",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In New Braunfels TX",
      "h2_subtitle": "Experience spacious living at Clear Springs with our two bedroom apartments. Enjoy modern amenities and a prime location in New Braunfels, TX.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. Our two bedrooms apartments for rent in New Braunfels TX feature thoughtfully designed interiors that will make you look forward to coming home every day. Each apartment includes modern amenities such as washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer, making meal preparation simple and convenient. Relax in your tub/shower or enjoy some fresh air on your private patio. At Clear Springs, we strive to provide a living experience that combines comfort and convenience in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Two Bedrooms Apartments For Rent In New Braunfels TX",
      "seo_description": "Discover two bedrooms apartments for rent in New Braunfels TX at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Pool",
      "h2_subtitle": "Enjoy resort-style living at Clear Springs with our beautiful pool. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent near me with pool, look no further. Our community features a stunning pool where you can relax and unwind. In addition to the pool, residents can enjoy a fitness center, lounge, and concierge cleaning services available by Spruce. Our apartments are designed with modern interiors that include washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent Near Me with Pool",
      "seo_description": "Find apartments for rent near me with pool at Clear Springs in New Braunfels, TX. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "Stay active and healthy at Clear Springs with our state-of-the-art fitness center. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent near me with fitness center, Clear Springs is the perfect choice. Our community features a state-of-the-art fitness center where you can stay active and healthy. In addition to the fitness center, residents can enjoy a pool, lounge, and concierge cleaning services available by Spruce. Our apartments are designed with modern interiors that include washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find apartments for rent near me with fitness center at Clear Springs in New Braunfels, TX. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-christus-hospital",
      "search_query": "Apartments For Rent In New Braunfels TX Near CHRISTUS Santa Rosa Hospital - New Braunfels",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near CHRISTUS Santa Rosa Hospital - New Braunfels",
      "h2_subtitle": "Live conveniently close to CHRISTUS Santa Rosa Hospital at Clear Springs. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near CHRISTUS Santa Rosa Hospital - New Braunfels, Clear Springs is the perfect choice. Our community is just a short drive from the hospital, making it an ideal location for healthcare professionals and patients alike. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near CHRISTUS Santa Rosa Hospital - New Braunfels",
      "seo_description": "Find apartments for rent in New Braunfels TX near CHRISTUS Santa Rosa Hospital at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-va-clinic",
      "search_query": "Apartments For Rent In New Braunfels TX Near New Braunfels VA Clinic",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near New Braunfels VA Clinic",
      "h2_subtitle": "Enjoy convenient living at Clear Springs, located near the New Braunfels VA Clinic. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near New Braunfels VA Clinic, Clear Springs is the perfect choice. Our community is conveniently located close to the VA Clinic, making it an ideal home for veterans and their families. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near New Braunfels VA Clinic",
      "seo_description": "Find apartments for rent in New Braunfels TX near New Braunfels VA Clinic at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-conviva-care",
      "search_query": "Apartments For Rent In New Braunfels TX Near Conviva Care Center",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near Conviva Care Center",
      "h2_subtitle": "Experience convenient living at Clear Springs, located near Conviva Care Center. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near Conviva Care Center, Clear Springs is the perfect choice. Our community is conveniently located close to Conviva Care Center, making it an ideal home for those seeking easy access to healthcare services. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near Conviva Care Center",
      "seo_description": "Find apartments for rent in New Braunfels TX near Conviva Care Center at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-resolute-health",
      "search_query": "Apartments For Rent In New Braunfels TX Near Resolute Health Hospital Medical Office Building",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near Resolute Health Hospital Medical Office Building",
      "h2_subtitle": "Enjoy convenient living at Clear Springs, located near Resolute Health Hospital Medical Office Building. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near Resolute Health Hospital Medical Office Building, Clear Springs is the perfect choice. Our community is conveniently located close to the medical office building, making it an ideal home for healthcare professionals and patients alike. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near Resolute Health Hospital Medical Office Building",
      "seo_description": "Find apartments for rent in New Braunfels TX near Resolute Health Hospital Medical Office Building at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-resolute-hospital",
      "search_query": "Apartments For Rent In New Braunfels TX Near Resolute Baptist Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near Resolute Baptist Hospital",
      "h2_subtitle": "Live conveniently close to Resolute Baptist Hospital at Clear Springs. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near Resolute Baptist Hospital, Clear Springs is the perfect choice. Our community is conveniently located close to the hospital, making it an ideal home for healthcare professionals and patients alike. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near Resolute Baptist Hospital",
      "seo_description": "Find apartments for rent in New Braunfels TX near Resolute Baptist Hospital at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-tlu",
      "search_query": "Apartments For Rent In New Braunfels TX Near Texas Lutheran University",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near Texas Lutheran University",
      "h2_subtitle": "Enjoy convenient living at Clear Springs, located near Texas Lutheran University. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near Texas Lutheran University, Clear Springs is the perfect choice. Our community is conveniently located close to the university, making it an ideal home for students, faculty, and staff. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near Texas Lutheran University",
      "seo_description": "Find apartments for rent in New Braunfels TX near Texas Lutheran University at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-moline-center",
      "search_query": "Apartments For Rent In New Braunfels TX Near Moline Center for Servant Leadership",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near Moline Center for Servant Leadership",
      "h2_subtitle": "Experience convenient living at Clear Springs, located near Moline Center for Servant Leadership. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near Moline Center for Servant Leadership, Clear Springs is the perfect choice. Our community is conveniently located close to the center, making it an ideal home for those involved in leadership and community service. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near Moline Center for Servant Leadership",
      "seo_description": "Find apartments for rent in New Braunfels TX near Moline Center for Servant Leadership at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-memorial-high",
      "search_query": "Apartments For Rent In New Braunfels TX Near Memorial Early College High School",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near Memorial Early College High School",
      "h2_subtitle": "Enjoy convenient living at Clear Springs, located near Memorial Early College High School. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near Memorial Early College High School, Clear Springs is the perfect choice. Our community is conveniently located close to the high school, making it an ideal home for students, faculty, and staff. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near Memorial Early College High School",
      "seo_description": "Find apartments for rent in New Braunfels TX near Memorial Early College High School at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-wayland-baptist-university",
      "search_query": "Apartments For Rent In New Braunfels TX Near Wayland Baptist University - San Antonio New Braunfels",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near Wayland Baptist University - San Antonio New Braunfels",
      "h2_subtitle": "Experience convenient living at Clear Springs, located near Wayland Baptist University - San Antonio New Braunfels. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near Wayland Baptist University - San Antonio New Braunfels, Clear Springs is the perfect choice. Our community is conveniently located close to the university, making it an ideal home for adult learners and faculty. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near Wayland Baptist University - San Antonio New Braunfels",
      "seo_description": "Find apartments for rent in New Braunfels TX near Wayland Baptist University - San Antonio New Braunfels at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-howard-payne",
      "search_query": "Apartments For Rent In New Braunfels TX Near Howard Payne University New Braunfels Center",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near Howard Payne University New Braunfels Center",
      "h2_subtitle": "Experience convenient living at Clear Springs, located near Howard Payne University New Braunfels Center. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near Howard Payne University New Braunfels Center, Clear Springs is the perfect choice. Our community is conveniently located close to the university, making it an ideal home for students, faculty, and staff. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near Howard Payne University New Braunfels Center",
      "seo_description": "Find apartments for rent in New Braunfels TX near Howard Payne University New Braunfels Center at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-canyon-high",
      "search_query": "Apartments For Rent In New Braunfels TX Near Canyon High School",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near Canyon High School",
      "h2_subtitle": "Enjoy family-friendly living at Clear Springs, located just 5.8 km from Canyon High School. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near Canyon High School, Clear Springs is the perfect choice for families. Our community is conveniently located just 5.8 km from Canyon High School, making it an ideal home for families looking to be in the award-winning William S. Hart Union High School District. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near Canyon High School",
      "seo_description": "Find apartments for rent in New Braunfels TX near Canyon High School at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-clear-spring",
      "search_query": "Apartments For Rent In New Braunfels TX Near Clear Spring Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near Clear Spring Elementary School",
      "h2_subtitle": "Enjoy family-friendly living at Clear Springs, located just 2.6 km from Clear Spring Elementary School. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near Clear Spring Elementary School, Clear Springs is the perfect choice for families. Our community is conveniently located just 2.6 km from Clear Spring Elementary School, making it an ideal home for families looking to be in a great school district. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near Clear Spring Elementary School",
      "seo_description": "Find apartments for rent in New Braunfels TX near Clear Spring Elementary School at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-freiheit-school",
      "search_query": "Apartments For Rent In New Braunfels TX Near Freiheit Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near Freiheit Elementary School",
      "h2_subtitle": "Enjoy family-friendly living at Clear Springs, located just 6.4 km from Freiheit Elementary School. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near Freiheit Elementary School, Clear Springs is the perfect choice for families. Our community is conveniently located just 6.4 km from Freiheit Elementary School, making it an ideal home for families looking to be in the Comal Independent School District. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near Freiheit Elementary School",
      "seo_description": "Find apartments for rent in New Braunfels TX near Freiheit Elementary School at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-farias-spitzer",
      "search_query": "Apartments For Rent In New Braunfels TX Near Farias-Spitzer Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near Farias-Spitzer Elementary School",
      "h2_subtitle": "Enjoy family-friendly living at Clear Springs, located just 1.5 km from Farias-Spitzer Elementary School. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near Farias-Spitzer Elementary School, Clear Springs is the perfect choice for families. Our community is conveniently located just 1.5 km from Farias-Spitzer Elementary School, making it an ideal home for families looking to be in a great school district. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near Farias-Spitzer Elementary School",
      "seo_description": "Find apartments for rent in New Braunfels TX near Farias-Spitzer Elementary School at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-church-hill",
      "search_query": "Apartments For Rent In New Braunfels TX Near Church Hill Middle School",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near Church Hill Middle School",
      "h2_subtitle": "Enjoy family-friendly living at Clear Springs, located just 5.4 km from Church Hill Middle School. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near Church Hill Middle School, Clear Springs is the perfect choice for families. Our community is conveniently located just 5.4 km from Church Hill Middle School, making it an ideal home for families looking to be in a great school district. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near Church Hill Middle School",
      "seo_description": "Find apartments for rent in New Braunfels TX near Church Hill Middle School at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5767618778628096",
      "source": "custom",
      "page_item_url": "apartments-for-rent-new-braunfels-tx-near-canyon-middle",
      "search_query": "Apartments For Rent In New Braunfels TX Near Canyon Middle School",
      "category": "POI",
      "h1_title": "Apartments For Rent In New Braunfels TX Near Canyon Middle School",
      "h2_subtitle": "Enjoy family-friendly living at Clear Springs, located just 6.7 km from Canyon Middle School. Our spacious apartments in New Braunfels, TX, offer modern amenities and a prime location.",
      "page_copy": "Clear Springs offers a wide variety of spacious one and two bedroom floor plans ideally located in New Braunfels, TX. If you're searching for apartments for rent in New Braunfels TX near Canyon Middle School, Clear Springs is the perfect choice for families. Our community is conveniently located just 6.7 km from Canyon Middle School, making it an ideal home for families looking to be in the Castro Valley Unified School District. Residents can enjoy modern amenities such as a business center, lounge, fitness center, and pool. Our apartments feature washer/dryer hookups, air conditioning, heating, and ceiling fans. The kitchen is fully equipped with a dishwasher, disposal, oven, refrigerator, and freezer. At Clear Springs, we aim to provide a living experience that combines comfort, convenience, and luxury in a prime location.",
      "featured_image": "https://irp.cdn-website.com/80c1b9bc/dms3rep/multi/clear-springs-apartments-new-braunfels-tx-resort-style-pool.jpg",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees",
        "public_id": "019f6c0d-ad5e-7473-a71b-e86bcc96e4f5",
        "storage_key": "property/5767618778628096/019f6c0d-ad5e-7473-a71b-e86bcc96e4f5.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Clear Springs | Apartments For Rent In New Braunfels TX Near Canyon Middle School",
      "seo_description": "Find apartments for rent in New Braunfels TX near Canyon Middle School at Clear Springs. Enjoy modern amenities and a prime location. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2287"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2505044029"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a24\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a24\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4981184"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MQFS6HP"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443948915"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "911abc1511f1ed33"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/60p7qz43w7n"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/8239a2a0-1585-4717-82bb-e0deef1f2214"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "830-494-0810"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlgyYUhBZzI2aVdtWUxMc05VZTI1cVE9PSIsInZhbHVlIjoiQ0JHU2hOQWtJZGNaQmFZUTNYaDhBdz09IiwibWFjIjoiNGVjYmMxOTNjZWVlMTA1MGQ1ZjdjZTM3Yzc4OTJiNmQ2YjhiMTYwY2NjZGFmYTk1OTc5OTc1NTQ1MTEyY2NiMiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2287",
  "custom_repli_id": "2505044029",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a24\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a24\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4981184",
  "custom_google_gtm_id": "GTM-MQFS6HP",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443948915",
  "custom_knock_community_id": "911abc1511f1ed33",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/60p7qz43w7n",
  "custom_self_guided_tour_url": "https://selftournow.com/property/8239a2a0-1585-4717-82bb-e0deef1f2214",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "830-494-0810",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlgyYUhBZzI2aVdtWUxMc05VZTI1cVE9PSIsInZhbHVlIjoiQ0JHU2hOQWtJZGNaQmFZUTNYaDhBdz09IiwibWFjIjoiNGVjYmMxOTNjZWVlMTA1MGQ1ZjdjZTM3Yzc4OTJiNmQ2YjhiMTYwY2NjZGFmYTk1OTc5OTc1NTQ1MTEyY2NiMiJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:39:57.205Z';
